import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, withKeys as _withKeys, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dbecb4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title", "aria-pressed"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 7.5 6 4l3.5 3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "nge-cl-title" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-tagwin-title" }, "Success!", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-tagwin-sub" }, "You solved the tagged tangle!", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-tabsettings-title" }, "Tabs on this panel", -1 /* HOISTED */))
const _hoisted_10 = ["checked", "onChange"]
const _hoisted_11 = {
  key: 1,
  class: "nge-cl-howto-panel"
}
const _hoisted_12 = { class: "nge-cl-howto-panel-head" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "How to map a cell", -1 /* HOISTED */))
const _hoisted_14 = { class: "nge-cl-filters nge-cl-filters--grouped" }
const _hoisted_15 = {
  key: 0,
  class: "nge-cl-tabgroup nge-cl-tabgroup--cells"
}
const _hoisted_16 = { class: "nge-cl-tabgroup-head" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-tabgroup-label" }, "Cells", -1 /* HOISTED */))
const _hoisted_18 = {
  key: 0,
  class: "nge-cl-headlinks"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "nge-cl-tabgroup-row" }
const _hoisted_22 = ["title"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  class: "nge-cl-tabgroup nge-cl-tabgroup--community"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-tabgroup-label" }, "Community", -1 /* HOISTED */))
const _hoisted_26 = { class: "nge-cl-tabgroup-row" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 2,
  class: "nge-cl-tabgroup nge-cl-tabgroup--mine"
}
const _hoisted_29 = { class: "nge-cl-tabgroup-head" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-tabgroup-label" }, "Yours", -1 /* HOISTED */))
const _hoisted_31 = {
  key: 0,
  class: "nge-cl-headlinks"
}
const _hoisted_32 = { class: "nge-cl-tabgroup-row" }
const _hoisted_33 = {
  key: 2,
  class: "nge-cl-search"
}
const _hoisted_34 = ["disabled", "title"]
const _hoisted_35 = {
  key: 0,
  class: "nge-cl-spin"
}
const _hoisted_36 = {
  key: 3,
  class: "nge-cl-search"
}
const _hoisted_37 = {
  key: 4,
  class: "nge-cl-list"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-help-open-plus" }, "👥", -1 /* HOISTED */))
const _hoisted_39 = {
  key: 1,
  class: "nge-cl-solved",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-solved-check",
  "aria-hidden": "true"
}, "✓", -1 /* HOISTED */))
const _hoisted_41 = ["src"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-solved-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Solved!"),
  /*#__PURE__*/_createTextVNode(" Thanks for closing the loop. It moved to Resolved.")
], -1 /* HOISTED */))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-help-open-plus" }, "+", -1 /* HOISTED */))
const _hoisted_44 = {
  key: 3,
  class: "nge-cl-help-quickadd"
}
const _hoisted_45 = {
  class: "nge-cl-help-kind",
  role: "radiogroup",
  "aria-label": "Kind of help"
}
const _hoisted_46 = ["aria-checked"]
const _hoisted_47 = ["aria-checked"]
const _hoisted_48 = {
  key: 0,
  class: "nge-cl-help-kind-note"
}
const _hoisted_49 = {
  key: 1,
  class: "nge-cl-help-tochat",
  title: "Your request is also said in chat with a button that opens your view, so someone can look and answer there."
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Also post to chat", -1 /* HOISTED */))
const _hoisted_51 = { class: "nge-cl-help-quickadd-row" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["value"]
const _hoisted_54 = ["aria-expanded"]
const _hoisted_55 = { class: "nge-cl-help-layers-summary" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-help-layers-caret",
  "aria-hidden": "true"
}, "▾", -1 /* HOISTED */))
const _hoisted_57 = {
  key: 0,
  class: "nge-cl-help-layers-menu",
  role: "group",
  "aria-label": "Annotation layers to point the helper at"
}
const _hoisted_58 = { class: "nge-cl-help-layers-item nge-cl-help-layers-item--all" }
const _hoisted_59 = ["checked"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All annotation layers", -1 /* HOISTED */))
const _hoisted_61 = ["title"]
const _hoisted_62 = ["checked", "onChange"]
const _hoisted_63 = { class: "nge-cl-help-quickadd-row" }
const _hoisted_64 = ["onKeydown"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "15",
  height: "15",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.7",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 8h3l2-2.5h8L18 8h3v11H3z" }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "13.5",
    r: "3.8"
  })
], -1 /* HOISTED */))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = ["title"]
const _hoisted_68 = {
  key: 3,
  class: "nge-cl-help-shot-preview nge-cl-help-shot-preview--sm"
}
const _hoisted_69 = ["src"]
const _hoisted_70 = {
  key: 4,
  class: "nge-cl-help-create-err"
}
const _hoisted_71 = {
  key: 4,
  class: "nge-cl-help-scope",
  role: "group",
  "aria-label": "Which help requests to show"
}
const _hoisted_72 = ["aria-pressed"]
const _hoisted_73 = ["aria-pressed"]
const _hoisted_74 = {
  key: 5,
  class: "nge-cl-empty"
}
const _hoisted_75 = {
  key: 6,
  class: "nge-cl-no-results"
}
const _hoisted_76 = ["onClick"]
const _hoisted_77 = ["title"]
const _hoisted_78 = {
  key: 0,
  class: "nge-cl-help-ds-tag nge-cl-help-ds-tag--current"
}
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "nge-cl-help-ds-count" }
const _hoisted_81 = ["data-help-id"]
const _hoisted_82 = { class: "nge-cl-row" }
const _hoisted_83 = { class: "nge-cl-row-left" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-pip nge-cl-status--help" }, null, -1 /* HOISTED */))
const _hoisted_85 = { class: "nge-cl-row-info" }
const _hoisted_86 = ["onClick", "title"]
const _hoisted_87 = {
  key: 0,
  class: "nge-cl-copied"
}
const _hoisted_88 = { class: "nge-cl-row-meta" }
const _hoisted_89 = {
  key: 0,
  class: "nge-cl-notes"
}
const _hoisted_90 = { class: "nge-cl-notes" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = ["onClick"]
const _hoisted_94 = ["title"]
const _hoisted_95 = ["href"]
const _hoisted_96 = ["src"]
const _hoisted_97 = { class: "nge-cl-row-actions" }
const _hoisted_98 = ["onClick"]
const _hoisted_99 = ["onClick", "title"]
const _hoisted_100 = ["disabled", "title", "onClick"]
const _hoisted_101 = ["onClick", "title"]
const _hoisted_102 = ["onClick", "title"]
const _hoisted_103 = {
  key: 0,
  class: "nge-cl-response-display"
}
const _hoisted_104 = { class: "nge-cl-response-label" }
const _hoisted_105 = { key: 0 }
const _hoisted_106 = {
  key: 0,
  class: "nge-cl-response-text"
}
const _hoisted_107 = ["onClick"]
const _hoisted_108 = {
  key: 2,
  class: "nge-cl-response-layer"
}
const _hoisted_109 = ["href"]
const _hoisted_110 = ["src"]
const _hoisted_111 = ["onClick"]
const _hoisted_112 = {
  key: 1,
  class: "nge-cl-response-form"
}
const _hoisted_113 = ["onKeydown"]
const _hoisted_114 = { class: "nge-cl-response-url-row" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select annotation layer (optional)", -1 /* HOISTED */))
const _hoisted_116 = ["value"]
const _hoisted_117 = {
  key: 2,
  class: "nge-cl-help-shot-preview"
}
const _hoisted_118 = ["src"]
const _hoisted_119 = ["disabled", "onClick"]
const _hoisted_120 = ["disabled", "onClick"]
const _hoisted_121 = ["data-help-id"]
const _hoisted_122 = { class: "nge-cl-row nge-cl-row--done" }
const _hoisted_123 = { class: "nge-cl-row-left" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-pip",
  style: {"background":"#556"}
}, null, -1 /* HOISTED */))
const _hoisted_125 = { class: "nge-cl-row-info" }
const _hoisted_126 = ["onClick", "title"]
const _hoisted_127 = { class: "nge-cl-row-meta" }
const _hoisted_128 = {
  class: "nge-cl-badge",
  style: {"background":"rgba(85,102,119,0.15)","color":"#889"}
}
const _hoisted_129 = {
  key: 0,
  class: "nge-cl-notes",
  style: {"color":"#7f8"}
}
const _hoisted_130 = { class: "nge-cl-notes" }
const _hoisted_131 = { class: "nge-cl-row-actions" }
const _hoisted_132 = ["onClick"]
const _hoisted_133 = ["onClick"]
const _hoisted_134 = ["onClick"]
const _hoisted_135 = {
  key: 0,
  class: "nge-cl-response-display"
}
const _hoisted_136 = { class: "nge-cl-response-label" }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = {
  key: 0,
  class: "nge-cl-response-text"
}
const _hoisted_139 = ["onClick"]
const _hoisted_140 = {
  key: 2,
  class: "nge-cl-response-layer"
}
const _hoisted_141 = ["href"]
const _hoisted_142 = ["src"]
const _hoisted_143 = { class: "nge-cl-quest" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-quest-title" }, "Learn more at connectome.quest", -1 /* HOISTED */))
const _hoisted_145 = { class: "nge-cl-quest-grid" }
const _hoisted_146 = ["href", "title"]
const _hoisted_147 = { class: "nge-cl-quest-icon" }
const _hoisted_148 = { class: "nge-cl-quest-label" }
const _hoisted_149 = { class: "nge-cl-list" }
const _hoisted_150 = { class: "nge-cl-list" }
const _hoisted_151 = {
  key: 1,
  class: "nge-cl-empty nge-cl-quests-elsewhere"
}
const _hoisted_152 = { class: "nge-cl-quests-elsewhere-text" }
const _hoisted_153 = {
  key: 0,
  class: "nge-cl-quests-elsewhere-text"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 4.5 6 8l3.5-3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_155 = [
  _hoisted_154
]
const _hoisted_156 = { class: "nge-cl-list" }
const _hoisted_157 = { class: "nge-cl-list" }
const _hoisted_158 = {
  class: "nge-cl-quest",
  style: {"margin-top":"0"}
}
const _hoisted_159 = { class: "nge-cl-quest-title" }
const _hoisted_160 = ["innerHTML"]
const _hoisted_161 = { class: "nge-cl-tags-hint" }
const _hoisted_162 = ["innerHTML"]
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-cl-tags-hint",
  style: {"margin-top":"6px","margin-bottom":"8px"}
}, [
  /*#__PURE__*/_createTextVNode(" Tags appear on the map while "),
  /*#__PURE__*/_createElementVNode("b", null, "Scout Tag mode"),
  /*#__PURE__*/_createTextVNode(" is open. Jump ↗ takes you to any tag. ")
], -1 /* HOISTED */))
const _hoisted_164 = { class: "nge-cl-tags-lanes" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-lanes-label" }, "Dataset", -1 /* HOISTED */))
const _hoisted_166 = { class: "nge-cl-tags-lanes" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-lanes-label" }, "Type", -1 /* HOISTED */))
const _hoisted_168 = ["src"]
const _hoisted_169 = ["src"]
const _hoisted_170 = {
  key: 0,
  class: "nge-cl-tags-hint",
  style: {"padding":"10px 0"}
}
const _hoisted_171 = { class: "nge-cl-row" }
const _hoisted_172 = { class: "nge-cl-row-left" }
const _hoisted_173 = { class: "nge-cl-row-info" }
const _hoisted_174 = { class: "nge-cl-row-name" }
const _hoisted_175 = {
  key: 0,
  class: "nge-cl-notes"
}
const _hoisted_176 = { class: "nge-cl-row-meta" }
const _hoisted_177 = { class: "nge-cl-notes" }
const _hoisted_178 = {
  key: 0,
  class: "nge-cl-badge",
  style: {"background":"rgba(245,209,66,0.12)","color":"#f5d142"}
}
const _hoisted_179 = { class: "nge-cl-notes" }
const _hoisted_180 = {
  key: 0,
  class: "nge-cl-notes",
  style: {"margin-top":"2px"}
}
const _hoisted_181 = {
  key: 1,
  class: "nge-cl-notes",
  style: {"margin-top":"2px"}
}
const _hoisted_182 = ["href"]
const _hoisted_183 = ["src"]
const _hoisted_184 = { class: "nge-cl-row-actions" }
const _hoisted_185 = { class: "nge-orbit-wrap" }
const _hoisted_186 = {
  key: 0,
  class: "nge-orbit-dot",
  "aria-hidden": "true"
}
const _hoisted_187 = ["onClick", "title"]
const _hoisted_188 = ["onClick"]
const _hoisted_189 = ["onClick"]
const _hoisted_190 = ["onClick"]
const _hoisted_191 = { class: "nge-cl-row nge-cl-row--done" }
const _hoisted_192 = { class: "nge-cl-row-left" }
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-pip",
  style: {"background":"#556"}
}, null, -1 /* HOISTED */))
const _hoisted_194 = { class: "nge-cl-row-info" }
const _hoisted_195 = { class: "nge-cl-row-name" }
const _hoisted_196 = { class: "nge-cl-row-meta" }
const _hoisted_197 = {
  key: 0,
  class: "nge-cl-notes",
  style: {"color":"#7f8"}
}
const _hoisted_198 = { class: "nge-cl-notes" }
const _hoisted_199 = { class: "nge-cl-row-actions" }
const _hoisted_200 = ["onClick"]
const _hoisted_201 = ["onClick"]
const _hoisted_202 = { class: "nge-cl-list" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nge-cl-quest",
  style: {"margin-top":"0"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-quest-title" }, "🤖 AI-predicted reconstruction errors"),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-ai-credit" }, "from the Dorkenwald and Fuming model"),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-ai-scale" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-ai-dot nge-cl-ai-dot--cool" }),
    /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-ai-scale-bar" }),
    /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-ai-dot nge-cl-ai-dot--hot" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-ai-scale-labels" }, [
    /*#__PURE__*/_createElementVNode("span", null, "less confident"),
    /*#__PURE__*/_createElementVNode("span", null, "more confident")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "nge-cl-tags-hint",
    style: {"margin-top":"8px"}
  }, " Jump ↗ to a candidate to see the proposed split as a red and blue point constellation, fix it, and mark it resolved. ")
], -1 /* HOISTED */))
const _hoisted_204 = { class: "nge-cl-tags-lanes" }
const _hoisted_205 = {
  class: "nge-cl-notes",
  style: {"align-self":"center"}
}
const _hoisted_206 = ["title"]
const _hoisted_207 = {
  key: 0,
  class: "nge-cl-tags-hint",
  style: {"padding":"10px 4px"}
}
const _hoisted_208 = {
  key: 1,
  class: "nge-cl-tags-lanes"
}
const _hoisted_209 = ["title", "onClick"]
const _hoisted_210 = ["onClick", "title"]
const _hoisted_211 = { class: "nge-cl-ai-group-caret" }
const _hoisted_212 = { class: "nge-cl-ai-group-name" }
const _hoisted_213 = { class: "nge-cl-notes" }
const _hoisted_214 = ["disabled", "onClick"]
const _hoisted_215 = { class: "nge-cl-row" }
const _hoisted_216 = { class: "nge-cl-row-left" }
const _hoisted_217 = { class: "nge-cl-row-info" }
const _hoisted_218 = { class: "nge-cl-row-name" }
const _hoisted_219 = {
  key: 0,
  class: "nge-cl-notes"
}
const _hoisted_220 = { class: "nge-cl-row-meta" }
const _hoisted_221 = { class: "nge-cl-notes" }
const _hoisted_222 = {
  key: 0,
  class: "nge-cl-badge",
  style: {"background":"rgba(245,209,66,0.12)","color":"#f5d142"}
}
const _hoisted_223 = { class: "nge-cl-row-actions" }
const _hoisted_224 = { class: "nge-orbit-wrap" }
const _hoisted_225 = {
  key: 0,
  class: "nge-orbit-dot",
  "aria-hidden": "true"
}
const _hoisted_226 = ["onClick", "disabled", "title"]
const _hoisted_227 = ["disabled", "onClick"]
const _hoisted_228 = ["onClick"]
const _hoisted_229 = ["onClick"]
const _hoisted_230 = ["onClick"]
const _hoisted_231 = { class: "nge-cl-row nge-cl-row--done" }
const _hoisted_232 = { class: "nge-cl-row-left" }
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-pip",
  style: {"background":"#556"}
}, null, -1 /* HOISTED */))
const _hoisted_234 = { class: "nge-cl-row-info" }
const _hoisted_235 = { class: "nge-cl-row-name" }
const _hoisted_236 = { class: "nge-cl-row-meta" }
const _hoisted_237 = {
  key: 0,
  class: "nge-cl-notes",
  style: {"color":"#7f8"}
}
const _hoisted_238 = { class: "nge-cl-notes" }
const _hoisted_239 = { class: "nge-cl-row-actions" }
const _hoisted_240 = ["onClick"]
const _hoisted_241 = ["onClick"]
const _hoisted_242 = { class: "nge-cl-list" }
const _hoisted_243 = {
  key: 0,
  class: "nge-cl-help-create"
}
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-help-create-title" }, "Save Current View", -1 /* HOISTED */))
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-help-create-hint" }, " Captures the current URL, dataset, position, and visible segments. ", -1 /* HOISTED */))
const _hoisted_246 = ["onKeydown"]
const _hoisted_247 = { class: "nge-cl-link-public-row" }
const _hoisted_248 = {
  key: 0,
  class: "nge-cl-help-shot-preview nge-cl-help-shot-preview--sm"
}
const _hoisted_249 = ["src"]
const _hoisted_250 = { class: "nge-cl-help-create-actions" }
const _hoisted_251 = { class: "nge-cl-link-ownership" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-link-ownership-divider" }, null, -1 /* HOISTED */))
const _hoisted_253 = {
  key: 0,
  class: "nge-cl-empty"
}
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "+", -1 /* HOISTED */))
const _hoisted_255 = { class: "nge-cl-row" }
const _hoisted_256 = { class: "nge-cl-row-left" }
const _hoisted_257 = { class: "nge-cl-row-info" }
const _hoisted_258 = {
  key: 0,
  class: "nge-cl-link-rename"
}
const _hoisted_259 = ["onKeydown", "onBlur"]
const _hoisted_260 = ["onDblclick", "title"]
const _hoisted_261 = { class: "nge-cl-row-meta" }
const _hoisted_262 = {
  key: 1,
  class: "nge-cl-notes"
}
const _hoisted_263 = {
  key: 2,
  class: "nge-cl-notes",
  style: {"color":"#7f8"}
}
const _hoisted_264 = { class: "nge-cl-notes" }
const _hoisted_265 = {
  key: 2,
  class: "nge-cl-help-note"
}
const _hoisted_266 = ["href"]
const _hoisted_267 = ["src"]
const _hoisted_268 = { class: "nge-cl-row-actions" }
const _hoisted_269 = ["onClick"]
const _hoisted_270 = ["onClick", "title"]
const _hoisted_271 = ["onClick"]
const _hoisted_272 = ["onClick"]
const _hoisted_273 = ["onClick"]
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-loading" }, "Loading cells...", -1 /* HOISTED */))
const _hoisted_275 = { class: "nge-cl-empty" }
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No cells loaded yet.", -1 /* HOISTED */))
const _hoisted_277 = {
  key: 0,
  class: "nge-cl-hint"
}
const _hoisted_278 = { class: "nge-cl-list" }
const _hoisted_279 = {
  key: 1,
  class: "nge-cl-limit"
}
const _hoisted_280 = { class: "nge-cl-limit-head" }
const _hoisted_281 = {
  key: 2,
  class: "nge-cl-limit"
}
const _hoisted_282 = { class: "nge-cl-limit-head" }
const _hoisted_283 = ["disabled", "onClick"]
const _hoisted_284 = {
  key: 0,
  class: "nge-cl-spin"
}
const _hoisted_285 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-error-dismiss" }, "×", -1 /* HOISTED */))
const _hoisted_286 = {
  key: 4,
  class: "nge-cl-more"
}
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-spin" }),
  /*#__PURE__*/_createTextVNode(" Loading the rest of the cells...")
], -1 /* HOISTED */))
const _hoisted_288 = [
  _hoisted_287
]
const _hoisted_289 = {
  key: 5,
  class: "nge-cl-no-results"
}
const _hoisted_290 = {
  key: 6,
  class: "nge-cl-no-results"
}
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_292 = {
  key: 7,
  class: "nge-cl-no-results"
}
const _hoisted_293 = {
  key: 8,
  class: "nge-cl-giants-intro"
}
const _hoisted_294 = ["src"]
const _hoisted_295 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 4.5 6 8l3.5-3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_296 = [
  _hoisted_295
]
const _hoisted_297 = ["disabled", "title"]
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.5 2.5 8 6l-3.5 3.5",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_299 = [
  _hoisted_298
]
const _hoisted_300 = {
  key: 12,
  class: "nge-cl-slim-claim-row"
}
const _hoisted_301 = ["disabled", "title"]
const _hoisted_302 = { class: "nge-cl-row-left" }
const _hoisted_303 = { class: "nge-cl-row-info" }
const _hoisted_304 = ["onClick", "title"]
const _hoisted_305 = ["title"]
const _hoisted_306 = {
  key: 0,
  class: "nge-cl-copied"
}
const _hoisted_307 = { class: "nge-cl-row-meta" }
const _hoisted_308 = {
  key: 0,
  class: "nge-cl-claimer"
}
const _hoisted_309 = {
  key: 1,
  class: "nge-cl-claimer",
  title: "Marked this way in the cell sheet, so it is not offered to claim. A gamemaster clears it there."
}
const _hoisted_310 = ["title"]
const _hoisted_311 = {
  key: 3,
  class: "nge-cl-badge nge-cl-giant-cell",
  title: "A Super Quest: one at a time, for up to 2 months, and Pyr counts your active time on it."
}
const _hoisted_312 = ["title"]
const _hoisted_313 = {
  key: 5,
  class: "nge-cl-badge nge-cl-hunt-cell",
  title: "Proofread this one fully, to every end. It may become a Hunt. A claim on it is let go 24 hours after you claim it."
}
const _hoisted_314 = {
  key: 6,
  class: "nge-cl-notes"
}
const _hoisted_315 = {
  key: 0,
  class: "nge-cl-time nge-cl-quest-ends"
}
const _hoisted_316 = { class: "nge-cl-row-actions" }
const _hoisted_317 = ["disabled", "onClick"]
const _hoisted_318 = {
  key: 0,
  class: "nge-cl-spin"
}
const _hoisted_319 = ["title"]
const _hoisted_320 = ["onClick", "title"]
const _hoisted_321 = ["disabled", "onClick"]
const _hoisted_322 = {
  key: 0,
  class: "nge-cl-spin"
}
const _hoisted_323 = ["disabled", "onClick"]
const _hoisted_324 = ["disabled", "onClick"]
const _hoisted_325 = {
  key: 0,
  class: "nge-cl-spin"
}
const _hoisted_326 = ["onClick"]
const _hoisted_327 = {
  key: 1,
  class: "nge-cl-complete"
}
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-complete-title" }, "Complete this cell", -1 /* HOISTED */))
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-cl-complete-label" }, "How did it end?", -1 /* HOISTED */))
const _hoisted_330 = {
  class: "nge-cl-complete-statuses",
  role: "radiogroup",
  "aria-label": "How did it end?"
}
const _hoisted_331 = ["aria-checked", "title", "onClick"]
const _hoisted_332 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-cl-complete-label" }, "Cell type (optional)", -1 /* HOISTED */))
const _hoisted_333 = {
  key: 0,
  class: "nge-cl-complete-ai"
}
const _hoisted_334 = ["title"]
const _hoisted_335 = {
  key: 0,
  class: "nge-cl-complete-ai"
}
const _hoisted_336 = ["title"]
const _hoisted_337 = { class: "nge-cl-complete-typerow" }
const _hoisted_338 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Choose a type", -1 /* HOISTED */))
const _hoisted_339 = ["value", "title"]
const _hoisted_340 = {
  key: 2,
  class: "nge-cl-complete-msg nge-cl-complete-msg--bad"
}
const _hoisted_341 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-cl-complete-label" }, "Link to your finished cell", -1 /* HOISTED */))
const _hoisted_342 = { class: "nge-cl-complete-linkrow" }
const _hoisted_343 = ["disabled"]
const _hoisted_344 = {
  key: 3,
  class: "nge-cl-complete-msg nge-cl-complete-msg--bad"
}
const _hoisted_345 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-cl-complete-label" }, "Notes (optional)", -1 /* HOISTED */))
const _hoisted_346 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "nge-cl-complete-label" }, "Crosshairs", -1 /* HOISTED */))
const _hoisted_347 = ["disabled", "onClick"]
const _hoisted_348 = { class: "nge-cl-complete-actions" }
const _hoisted_349 = ["disabled", "title", "onClick"]
const _hoisted_350 = {
  key: 0,
  class: "nge-cl-spin"
}
const _hoisted_351 = ["disabled"]
const _hoisted_352 = {
  key: 13,
  class: "nge-cl-more"
}
const _hoisted_353 = ["disabled"]
const _hoisted_354 = {
  key: 0,
  class: "nge-cl-spin"
}
const _hoisted_355 = {
  key: 14,
  class: "nge-cl-login-hint"
}
const _hoisted_356 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 12 12",
  width: "12",
  height: "12",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 5 L5 11 M11 9 L9 11" })
], -1 /* HOISTED */))
const _hoisted_357 = [
  _hoisted_356
]
const _hoisted_358 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-title" }, "HELP REQUEST", -1 /* HOISTED */))
const _hoisted_359 = {
  key: 0,
  class: "nge-cl-popout-body nge-cl-popout-muted"
}
const _hoisted_360 = {
  key: 1,
  class: "nge-cl-popout-body"
}
const _hoisted_361 = { class: "nge-cl-popout-who" }
const _hoisted_362 = {
  key: 0,
  class: "nge-cl-popout-solved"
}
const _hoisted_363 = { class: "nge-cl-popout-cell" }
const _hoisted_364 = ["title"]
const _hoisted_365 = {
  key: 0,
  class: "nge-cl-copied"
}
const _hoisted_366 = {
  key: 1,
  class: "nge-cl-popout-muted"
}
const _hoisted_367 = {
  key: 0,
  class: "nge-cl-popout-question"
}
const _hoisted_368 = {
  key: 1,
  class: "nge-cl-popout-question nge-cl-popout-muted"
}
const _hoisted_369 = ["href"]
const _hoisted_370 = ["src"]
const _hoisted_371 = { class: "nge-cl-popout-links" }
const _hoisted_372 = {
  key: 1,
  class: "nge-cl-response-layer"
}
const _hoisted_373 = {
  key: 3,
  class: "nge-cl-solved",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_374 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "nge-cl-solved-check",
  "aria-hidden": "true"
}, "✓", -1 /* HOISTED */))
const _hoisted_375 = ["src"]
const _hoisted_376 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-cl-solved-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Solved!"),
  /*#__PURE__*/_createTextVNode(" Thanks for closing the loop. It moved to Resolved.")
], -1 /* HOISTED */))
const _hoisted_377 = { class: "nge-cl-popout-actions" }
const _hoisted_378 = ["disabled"]
const _hoisted_379 = ["title"]
const _hoisted_380 = {
  key: 4,
  class: "nge-cl-response-form nge-cl-popout-form"
}
const _hoisted_381 = { class: "nge-cl-response-url-row" }
const _hoisted_382 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select annotation layer (optional)", -1 /* HOISTED */))
const _hoisted_383 = ["value"]
const _hoisted_384 = {
  key: 2,
  class: "nge-cl-help-shot-preview"
}
const _hoisted_385 = ["src"]
const _hoisted_386 = ["disabled"]
const _hoisted_387 = ["disabled"]
const _hoisted_388 = { class: "nge-cl-popout-replies-title" }
const _hoisted_389 = { class: "nge-cl-response-label" }
const _hoisted_390 = { key: 0 }
const _hoisted_391 = {
  key: 0,
  class: "nge-cl-popout-reply-text"
}
const _hoisted_392 = ["onClick"]
const _hoisted_393 = {
  key: 2,
  class: "nge-cl-response-layer"
}
const _hoisted_394 = ["href"]
const _hoisted_395 = ["src"]
const _hoisted_396 = ["onClick"]
const _hoisted_397 = { class: "nge-cl-jumpconfirm" }
const _hoisted_398 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-cl-jumpconfirm-title" }, "⚠ Switching dataset", -1 /* HOISTED */))
const _hoisted_399 = { class: "nge-cl-jumpconfirm-body" }
const _hoisted_400 = {
  key: 0,
  class: "nge-cl-jumpconfirm-warn"
}
const _hoisted_401 = {
  key: 1,
  class: "nge-cl-jumpconfirm-warn"
}
const _hoisted_402 = { class: "nge-cl-jumpconfirm-url-row" }
const _hoisted_403 = ["value"]
const _hoisted_404 = { class: "nge-cl-jumpconfirm-save-row" }
const _hoisted_405 = ["disabled"]
const _hoisted_406 = { class: "nge-cl-jumpconfirm-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        name: "nge-cl",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: "panelEl",
            class: _normalizeClass(["nge-cl-panel", { 'nge-cl-panel--slim': $setup.slim }]),
            style: _normalizeStyle($setup.panelStyle),
            onMousedown: $setup.onSlimMouseDown
          }, [
            _createCommentVNode(" Top bar "),
            _createElementVNode("div", {
              class: _normalizeClass(["nge-cl-topbar", { 'nge-cl-dragging': $setup.isDragging }]),
              onMousedown: $setup.startDrag
            }, [
              _createCommentVNode(" Shrink on the left, where the slim bar keeps its expand arrow\n               (Ames 2026-10-20: \"the shrink/expand arrow should be\n               consistently left\") "),
              _createElementVNode("button", {
                class: _normalizeClass(["nge-cl-caret", { 'nge-cl-caret--on': $setup.slimMode }]),
                title: $setup.slimMode ? 'Slim view is on: jumping to a cell shrinks the library to that cell. Click to shrink now.' : 'Slim view: shrink the library to the cell you are working on',
                "aria-label": "Slim view",
                "aria-pressed": $setup.slimMode ? 'true' : 'false',
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                onClick: $setup.collapseToCurrent
              }, _hoisted_3, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: $setup.neuronIcon,
                  class: "nge-cl-icon"
                }, null, 8 /* PROPS */, _hoisted_5),
                _createTextVNode(" CELL LIBRARY ")
              ]),
              (!$setup.viewOnlyDataset)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "nge-cl-gear",
                    title: "Choose which tabs show",
                    onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                    onClick: _cache[2] || (_cache[2] = $event => ($setup.showTabSettings = !$setup.showTabSettings))
                  }, "⚙", 32 /* HYDRATE_EVENTS */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                class: "nge-cl-close",
                title: "Close (Shift+L)",
                "aria-label": "Close the Cell Library",
                onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                onClick: _cache[4] || (_cache[4] = $event => ($setup.emit('hide')))
              }, "×", 32 /* HYDRATE_EVENTS */)
            ], 34 /* CLASS, HYDRATE_EVENTS */),
            _createCommentVNode(" Resolve celebration "),
            _createVNode(_Transition, { name: "nge-cl-tagwin" }, {
              default: _withCtx(() => [
                ($setup.tagSuccessToast)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "nge-cl-tagwin",
                      onClick: _cache[5] || (_cache[5] = $event => ($setup.tagSuccessToast = false))
                    }, [
                      _createElementVNode("div", {
                        class: "nge-cl-tagwin-glyph",
                        innerHTML: $setup.tagPinSvg
                      }, null, 8 /* PROPS */, _hoisted_6),
                      _hoisted_7,
                      _hoisted_8
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            _createCommentVNode(" Per-user tab picker "),
            ($setup.showTabSettings)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "nge-cl-tabsettings",
                  onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _hoisted_9,
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.ALL_CL_TABS, (t) => {
                    return _createElementVNode("label", {
                      key: t.key,
                      class: "nge-cl-tabsettings-row"
                    }, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        checked: $setup.visibleTabs.includes(t.key),
                        onChange: $event => ($setup.toggleTab(t.key))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_10),
                      _createElementVNode("span", null, _toDisplayString(t.label), 1 /* TEXT */)
                    ])
                  }), 64 /* STABLE_FRAGMENT */))
                ], 32 /* HYDRATE_EVENTS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" How to proofread this dataset's cells (Retina). "),
            ($setup.datasetHowTo && $setup.showHowTo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("button", {
                      class: "nge-cl-howto-close",
                      onClick: _cache[7] || (_cache[7] = $event => ($setup.showHowTo = false)),
                      title: "Close"
                    }, "×")
                  ]),
                  _createCommentVNode(" Admins can change these in the game (Celia 2026-10-20). "),
                  _createVNode($setup["EditableText"], {
                    "text-key": $setup.datasetHowToKey,
                    original: $setup.datasetHowTo,
                    "list-class": "nge-cl-howto-steps"
                  }, null, 8 /* PROPS */, ["text-key", "original"])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Filter tabs "),
            _createCommentVNode(" Tabs in three coloured groups: cells (cyan), community (gold),\n             yours (violet). AI and Completed live in the gear picker. "),
            _createElementVNode("div", _hoisted_14, [
              (!$setup.viewOnlyDataset)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      ($setup.datasetHowTo || $setup.datasetInstructionsUrl || $setup.datasetCellTypesState || $setup.datasetTour)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                            ($setup.datasetTour)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "nge-cl-howto",
                                  href: "#",
                                  onClick: _cache[8] || (_cache[8] = _withModifiers($event => ($setup.startDatasetTour($setup.activeDataset)), ["prevent"])),
                                  title: "Replay the guided tour of this dataset's cell types"
                                }, "tour"))
                              : _createCommentVNode("v-if", true),
                            ($setup.datasetHowTo)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: _normalizeClass(["nge-cl-howto", { 'nge-cl-howto--open': $setup.showHowTo }]),
                                  href: "#",
                                  onClick: _cache[9] || (_cache[9] = _withModifiers($event => ($setup.showHowTo = !$setup.showHowTo), ["prevent"])),
                                  title: "How to proofread cells in this dataset"
                                }, "instructions", 2 /* CLASS */))
                              : ($setup.datasetInstructionsUrl)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 2,
                                    class: "nge-cl-howto",
                                    href: $setup.datasetInstructionsUrl,
                                    target: "_blank",
                                    rel: "noopener",
                                    title: "How to proofread cells in this dataset (opens in a new tab)"
                                  }, "instructions", 8 /* PROPS */, _hoisted_19))
                                : _createCommentVNode("v-if", true),
                            ($setup.datasetCellTypesState)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 3,
                                  class: "nge-cl-howto",
                                  href: "#",
                                  onClick: _withModifiers($setup.openCellTypes, ["prevent"]),
                                  title: "Open a view with one example of each cell type in this dataset"
                                }, "cell types", 8 /* PROPS */, _hoisted_20))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createCommentVNode(" Hunt candidates (the Hunt Builder), only while there are some: cells that may become a Hunt. "),
                      ($setup.huntCells.length)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass({ active: $setup.filter === 'hunt', 'nge-cl-hunt-tab': true }),
                            onClick: _cache[10] || (_cache[10] = $event => ($setup.filter = 'hunt')),
                            title: "Hunt candidates: cells that may become a Hunt. Proofread one fully, to every end. A claim on one is let go 24 hours after you claim it, so the cell is not held up."
                          }, [
                            _createTextVNode(" Hunt "),
                            _createElementVNode("b", null, _toDisplayString($setup.huntOpenCount), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Super Quests (Ames 2026-10-28): giant MEC interneurons, only on a dataset that has some. "),
                      ($setup.questCells.length)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass({ active: $setup.filter === 'giants', 'nge-cl-giants-tab': true }),
                            onClick: _cache[11] || (_cache[11] = $event => ($setup.filter = 'giants')),
                            title: "Super Quests: giant interneurons that have never been mapped before. One can take weeks. You hold one at a time, beside your other claims, for up to 2 months. The number is the Super Quests open to claim."
                          }, [
                            _createTextVNode(" Super Quests "),
                            _createElementVNode("b", null, _toDisplayString($setup.questOpenHere), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($setup.tabShown('mine'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: _normalizeClass({ active: $setup.filter === 'mine' }),
                            onClick: _cache[12] || (_cache[12] = $event => ($setup.filter = 'mine')),
                            title: "Cells you have claimed, and cells you completed"
                          }, [
                            _createTextVNode(" My Cells "),
                            _createElementVNode("b", null, _toDisplayString($setup.myClaimCount), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($setup.tabShown('available'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            class: _normalizeClass({ active: $setup.filter === 'available' }),
                            onClick: _cache[13] || (_cache[13] = $event => ($setup.filter = 'available')),
                            title: "Cells nobody has claimed yet"
                          }, [
                            _createTextVNode(" Available "),
                            _createElementVNode("b", null, _toDisplayString($setup.availableCount), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($setup.tabShown('claimed'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            class: _normalizeClass({ active: $setup.filter === 'claimed', 'nge-cl-claimed-tab': true }),
                            onClick: _cache[14] || (_cache[14] = $event => ($setup.filter = 'claimed')),
                            title: "Cells anyone has claimed and is working on, yours included"
                          }, [
                            _createTextVNode(" Claimed "),
                            _createElementVNode("b", null, _toDisplayString($setup.claimedCount), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($setup.tabShown('all'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 5,
                            class: _normalizeClass({ active: $setup.filter === 'all' }),
                            onClick: _cache[15] || (_cache[15] = $event => ($setup.filter = 'all')),
                            title: "Every cell in this dataset"
                          }, [
                            _createTextVNode(" All "),
                            _createElementVNode("b", null, _toDisplayString($setup.allCount), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Quests are cells you claim, so they sit with the cells (Ames 2026-10-13). "),
                      ($setup.tabShown('quests'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 6,
                            class: _normalizeClass({ active: $setup.filter === 'quests', 'nge-cl-quests-tab': true }),
                            onClick: _cache[16] || (_cache[16] = $event => ($setup.filter = 'quests')),
                            title: $setup.questsHere ? 'Annotation quests: mark the cilia on a starburst amacrine cell, without completing it. The number is the cells open to claim.' : 'Annotation quests are on Retina for now'
                          }, [
                            _createTextVNode(" Quests "),
                            ($setup.questsHere && $setup.questState.loaded)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_23, _toDisplayString($setup.questOpenCount()), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ], 10 /* CLASS, PROPS */, _hoisted_22))
                        : _createCommentVNode("v-if", true),
                      ($setup.castHere && $setup.tabShown('cast'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 7,
                            class: _normalizeClass({ active: $setup.filter === 'cast', 'nge-cl-cast-tab': true }),
                            onClick: _cache[17] || (_cache[17] = $event => ($setup.filter = 'cast')),
                            title: "One example cell of each retinal type, to turn in 3D, alone or all together"
                          }, [
                            _createTextVNode(" Meet the cells "),
                            _createElementVNode("b", null, _toDisplayString($setup.CAST.length), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($setup.tabShown('completed'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 8,
                            class: _normalizeClass({ active: $setup.filter === 'completed' }),
                            onClick: _cache[18] || (_cache[18] = $event => ($setup.filter = 'completed'))
                          }, [
                            _createTextVNode(" Completed "),
                            _createElementVNode("b", null, _toDisplayString($setup.completedCount), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('help') || $setup.tabShown('tags') || $setup.tabShown('ai'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      ($setup.tabShown('help'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: _normalizeClass({ active: $setup.filter === 'help', 'nge-cl-help-tab': true }),
                            onClick: _cache[19] || (_cache[19] = $event => ($setup.filter = 'help')),
                            title: "Questions from other proofreaders"
                          }, [
                            _createTextVNode(" Help "),
                            _createElementVNode("b", null, _toDisplayString($setup.pendingHelp.length), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($setup.teamsHere && $setup.tabShown('teams'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: _normalizeClass({ active: $setup.filter === 'teams', 'nge-cl-teams-tab': true }),
                            onClick: _cache[20] || (_cache[20] = $event => ($setup.filter = 'teams')),
                            title: "Two to four players on one cell, each working when they can"
                          }, [
                            _createTextVNode(" Teams "),
                            ($setup.teamInvites)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_27, _toDisplayString($setup.teamInvites), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($setup.tabShown('tags'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: _normalizeClass({ active: $setup.filter === 'tags', 'nge-cl-tags-tab': true }),
                            onClick: _cache[21] || (_cache[21] = $event => ($setup.filter = 'tags')),
                            title: "Scout tags: spots someone flagged to cut or extend"
                          }, [
                            _createTextVNode(" Tags "),
                            _createElementVNode("b", null, _toDisplayString($setup.datasetTags.length), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                      ($setup.tabShown('ai'))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            class: _normalizeClass({ active: $setup.filter === 'ai', 'nge-cl-ai-tab': true }),
                            onClick: _cache[22] || (_cache[22] = $event => ($setup.filter = 'ai'))
                          }, [
                            _createTextVNode(" AI "),
                            _createElementVNode("b", null, _toDisplayString($setup.aiDatasetTags.length), 1 /* TEXT */)
                          ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.tabShown('links'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createCommentVNode(" the tour link lives with the cell tabs; here they are gone "),
                      ($setup.viewOnlyDataset && $setup.datasetTour)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                            _createElementVNode("a", {
                              class: "nge-cl-howto",
                              href: "#",
                              onClick: _cache[23] || (_cache[23] = _withModifiers($event => ($setup.startDatasetTour($setup.activeDataset)), ["prevent"])),
                              title: "Replay the guided tour of this dataset's cell types"
                            }, "tour")
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("button", {
                        class: _normalizeClass({ active: $setup.filter === 'links', 'nge-cl-links-tab': true }),
                        onClick: _cache[24] || (_cache[24] = $event => ($setup.filter = 'links')),
                        title: "Links you saved"
                      }, [
                        _createTextVNode(" My Links "),
                        _createElementVNode("b", null, _toDisplayString($setup.linksStore.links.length), 1 /* TEXT */)
                      ], 2 /* CLASS */)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Search (not shown on Help / Links tabs) "),
            ($setup.filter !== 'help' && $setup.filter !== 'links' && $setup.filter !== 'tags' && $setup.filter !== 'ai' && $setup.filter !== 'teams' && $setup.filter !== 'cast')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => (($setup.search) = $event)),
                    placeholder: "Search by ID, name, or notes...",
                    class: "nge-cl-search-input",
                    onKeydown: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"])),
                    onKeyup: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.search]
                  ]),
                  ($setup.filter === 'available' && $setup.isLoggedIn && ($setup.batchRoom > 0 || $setup.batchClaiming))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-cl-btn nge-cl-batch-claim",
                        disabled: !!$setup.batchClaiming,
                        onClick: $setup.batchClaim,
                        title: $setup.batchStart
                    ? `Claim ${$setup.batchStartName} and the available cells after it, ${Math.min($setup.batchRoom, $setup.batchCandidates.length)} in all (up to ${$setup.backend.claimLimitFor()} at a time)`
                    : `Claim the next ${$setup.batchRoom} available cells in this list (up to ${$setup.backend.claimLimitFor()} at a time)`
                      }, [
                        ($setup.batchClaiming)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(_toDisplayString($setup.batchClaiming ? `Claiming ${$setup.batchClaiming.done}/${$setup.batchClaiming.total}…` : $setup.batchStart ? $setup.batchFromLabel : `Claim ${$setup.batchRoom}`), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_34))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Search on Links tab "),
            ($setup.filter === 'links')
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => (($setup.linksSearch) = $event)),
                    placeholder: "Search links by title, note, or dataset...",
                    class: "nge-cl-search-input",
                    onKeydown: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["stop"])),
                    onKeyup: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[32] || (_cache[32] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.linksSearch]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" ═══ HELP TAB ═══ "),
            ($setup.filter === 'help')
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createCommentVNode(" Team mode: two or more players on one cell, live. "),
                  ($setup.teamsHere)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-cl-help-open-btn nge-cl-team-btn",
                        onClick: $setup.teamUp,
                        title: "Work on the cell in your view together with other players, live. You invite them by name."
                      }, [
                        _hoisted_38,
                        _createTextVNode(" Team up on this cell ")
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" Always-visible quick-add: submit a new help request from the top "),
                  _createCommentVNode(" Collapsed by default: a permanently-open form at the top of the\n               tab read as an alert rather than an action. "),
                  ($setup.solvedFlash)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("img", {
                          src: $setup.nurroCelebrate,
                          class: "nge-cl-solved-nurro",
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_41),
                        _hoisted_42
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!$setup.helpFormOpen)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "nge-cl-help-open-btn",
                        onClick: $setup.toggleHelpForm,
                        title: "Ask another proofreader to look at a cell"
                      }, [
                        _hoisted_43,
                        _createTextVNode(" Submit a help request ")
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("div", { class: "nge-cl-help-quickadd-title" }, [
                          _createTextVNode(" Submit a help request "),
                          _createElementVNode("button", {
                            class: "nge-cl-help-collapse",
                            onClick: $setup.toggleHelpForm,
                            title: "Collapse"
                          }, "▾")
                        ]),
                        _createCommentVNode(" Two kinds of request: one that waits for a reply, and a live\n                 one that asks someone to join your view now (Mentor mode). "),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("button", {
                            type: "button",
                            role: "radio",
                            "aria-checked": !$setup.newHelpLive ? 'true' : 'false',
                            class: "nge-cl-help-kind-opt",
                            title: "Your request waits in the Help tab. Someone replies when they can.",
                            onClick: _cache[33] || (_cache[33] = $event => ($setup.newHelpLive = false))
                          }, "Leave a request", 8 /* PROPS */, _hoisted_46),
                          _createElementVNode("button", {
                            type: "button",
                            role: "radio",
                            "aria-checked": $setup.newHelpLive ? 'true' : 'false',
                            class: "nge-cl-help-kind-opt nge-cl-help-kind-opt--live",
                            title: "Asks in chat for a player to join your view and help you now. You choose whether to accept who offers.",
                            onClick: _cache[34] || (_cache[34] = $event => ($setup.newHelpLive = true))
                          }, "🤝 Live help now", 8 /* PROPS */, _hoisted_47)
                        ]),
                        ($setup.newHelpLive)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, "Posts to chat. A player with production access can offer to join your view, and you accept or decline."))
                          : (_openBlock(), _createElementBlock("label", _hoisted_49, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => (($setup.newHelpToChat) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelCheckbox, $setup.newHelpToChat]
                              ]),
                              _hoisted_50
                            ])),
                        _createElementVNode("div", _hoisted_51, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => (($setup.newHelpLink) = $event)),
                            class: "nge-cl-help-segid-input",
                            placeholder: "Your view is attached when you send",
                            onKeydown: _cache[37] || (_cache[37] = _withModifiers(() => {}, ["stop"])),
                            onKeyup: _cache[38] || (_cache[38] = _withModifiers(() => {}, ["stop"])),
                            onKeypress: _cache[39] || (_cache[39] = _withModifiers(() => {}, ["stop"])),
                            onInput: _cache[40] || (_cache[40] = $event => ($setup.newHelpError = ''))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelText, $setup.newHelpLink]
                          ]),
                          _createElementVNode("button", {
                            class: "nge-cl-help-segid-use",
                            disabled: $setup.newHelpLinkMinting,
                            onClick: $setup.saveHelpLink,
                            title: "The link is filled in for you, and made again from what you are looking at when you send. Click to remake it now."
                          }, _toDisplayString($setup.newHelpLinkMinting ? 'Saving…' : 'Refresh link'), 9 /* TEXT, PROPS */, _hoisted_52),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => (($setup.newHelpIssue) = $event)),
                            class: "nge-cl-help-issue-select",
                            onKeydown: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["stop"])),
                            title: "Issue type"
                          }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.HELP_ISSUE_TYPES, (t) => {
                              return _createElementVNode("option", {
                                key: t,
                                value: t
                              }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_53)
                            }), 64 /* STABLE_FRAGMENT */))
                          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelSelect, $setup.newHelpIssue]
                          ])
                        ]),
                        _createCommentVNode(" Which annotation layers hold your marks: all of them unless\n                 you say otherwise, in one dropdown so many layers do not grow\n                 the form. The request's view carries every layer either way;\n                 this tells the helper where to look. "),
                        ($setup.getAnnotationLayers().length > 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              ref: "helpLayersEl",
                              class: "nge-cl-help-layers",
                              onKeydown: _cache[44] || (_cache[44] = _withKeys(_withModifiers($event => ($setup.helpLayersOpen = false), ["stop"]), ["esc"]))
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "nge-cl-help-layers-toggle",
                                "aria-expanded": $setup.helpLayersOpen ? 'true' : 'false',
                                "aria-haspopup": "true",
                                title: "Choose which annotation layers to point the helper at",
                                onClick: _cache[43] || (_cache[43] = $event => ($setup.helpLayersOpen = !$setup.helpLayersOpen))
                              }, [
                                _createElementVNode("span", _hoisted_55, "📐 " + _toDisplayString($setup.helpLayersSummary()), 1 /* TEXT */),
                                _hoisted_56
                              ], 8 /* PROPS */, _hoisted_54),
                              ($setup.helpLayersOpen)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _createElementVNode("label", _hoisted_58, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: $setup.newHelpAllLayers,
                                        onChange: $setup.toggleAllHelpLayers
                                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_59),
                                      _hoisted_60
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAnnotationLayers(), (layer) => {
                                      return (_openBlock(), _createElementBlock("label", {
                                        key: layer,
                                        class: "nge-cl-help-layers-item",
                                        title: layer
                                      }, [
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          checked: $setup.helpLayerOn(layer),
                                          onChange: $event => ($setup.toggleHelpLayer(layer))
                                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_62),
                                        _createElementVNode("span", null, _toDisplayString(layer), 1 /* TEXT */)
                                      ], 8 /* PROPS */, _hoisted_61))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_63, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => (($setup.newHelpNote) = $event)),
                            class: "nge-cl-help-note-input",
                            placeholder: "Describe what looks wrong, then press Enter…",
                            onKeydown: [
                              _cache[46] || (_cache[46] = _withModifiers(() => {}, ["stop"])),
                              _withKeys(_withModifiers($setup.submitNewHelp, ["prevent"]), ["enter"])
                            ],
                            onKeyup: _cache[47] || (_cache[47] = _withModifiers(() => {}, ["stop"])),
                            onKeypress: _cache[48] || (_cache[48] = _withModifiers(() => {}, ["stop"])),
                            onInput: _cache[49] || (_cache[49] = $event => ($setup.newHelpError = ''))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_64), [
                            [_vModelText, $setup.newHelpNote]
                          ]),
                          (!$setup.newHelpScreenshotUrl)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "nge-cl-help-shot-icon",
                                onClick: _cache[50] || (_cache[50] = $event => ($setup.showHelpScreenshotDialog = true)),
                                title: "Attach a screenshot of the current view"
                              }, _hoisted_66))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "nge-cl-help-shot-icon nge-cl-help-shot-icon--attached",
                                onClick: $setup.clearHelpScreenshot,
                                title: "Screenshot attached — click to remove"
                              }, "✓")),
                          _createElementVNode("button", {
                            class: "nge-cl-help-quickadd-submit",
                            onClick: $setup.submitNewHelp,
                            title: $setup.newHelpLive ? 'Ask in chat for someone to join your view and help now' : 'Submit help request'
                          }, _toDisplayString($setup.newHelpLive ? 'Ask now' : 'Submit'), 9 /* TEXT, PROPS */, _hoisted_67)
                        ]),
                        ($setup.newHelpScreenshotUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                              _createElementVNode("img", {
                                src: $setup.newHelpScreenshotUrl,
                                alt: "Attached screenshot"
                              }, null, 8 /* PROPS */, _hoisted_69),
                              _createElementVNode("button", {
                                class: "nge-cl-help-shot-remove",
                                onClick: $setup.clearHelpScreenshot,
                                title: "Remove screenshot"
                              }, "×")
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.newHelpError)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString($setup.newHelpError), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])),
                  _createCommentVNode(" Everyone's requests or only yours "),
                  ($setup.isLoggedIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass({ active: $setup.helpScope === 'all' }),
                          "aria-pressed": $setup.helpScope === 'all' ? 'true' : 'false',
                          onClick: _cache[51] || (_cache[51] = $event => ($setup.helpScope = 'all'))
                        }, [
                          _createTextVNode("All requests "),
                          _createElementVNode("b", null, _toDisplayString($setup.pendingHelp.length), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_72),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass({ active: $setup.helpScope === 'mine' }),
                          "aria-pressed": $setup.helpScope === 'mine' ? 'true' : 'false',
                          onClick: _cache[52] || (_cache[52] = $event => ($setup.helpScope = 'mine'))
                        }, [
                          _createTextVNode("Mine "),
                          _createElementVNode("b", null, _toDisplayString($setup.myOpenHelpCount), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_73)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" Pending help requests "),
                  ($setup.scopedPendingHelp.length === 0 && $setup.resolvedHelp.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString($setup.helpScope === 'mine' ? 'You have no help requests. Use the box above to ask for help.' : 'No help requests yet. Use the box above to submit one.'), 1 /* TEXT */))
                    : ($setup.scopedPendingHelp.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString($setup.helpScope === 'mine' ? 'None of your requests are open' : 'No pending requests'), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pendingHelpByDataset, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.dataset,
                      class: _normalizeClass(["nge-cl-help-ds-group", { 'nge-cl-help-ds-group--cross': !group.isCurrent }])
                    }, [
                      _createCommentVNode(" Dataset section header: shown with multiple groups, and ALSO\n                 for a lone non-current group. Without it, requests that all\n                 live in one other dataset auto-collapsed with no header to\n                 expand them: count said 2, list showed nothing (Amy). "),
                      ($setup.hasMultipleHelpDatasets || !group.isCurrent)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "nge-cl-help-ds-header",
                            onClick: $event => ($setup.toggleDatasetGroup(group.dataset))
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["nge-cl-help-ds-arrow", { 'nge-cl-help-ds-arrow--collapsed': !group.isCurrent && $setup.collapsedDatasets.has(group.dataset) }])
                            }, "▾", 2 /* CLASS */),
                            _createElementVNode("span", {
                              class: "nge-cl-help-ds-name",
                              title: group.label
                            }, _toDisplayString($setup.datasetHeading(group.dataset)), 9 /* TEXT, PROPS */, _hoisted_77),
                            (group.isCurrent)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_78, "viewing now"))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  class: "nge-cl-help-ds-tag nge-cl-help-ds-tag--other nge-cl-help-ds-switch",
                                  title: "Switch the viewer to this dataset",
                                  onClick: _withModifiers($event => ($setup.switchToDatasetGroup(group)), ["stop"])
                                }, "switch here", 8 /* PROPS */, _hoisted_79)),
                            _createElementVNode("span", _hoisted_80, _toDisplayString(group.requests.length), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_76))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" Requests: current dataset always shown; others only when expanded "),
                      (group.isCurrent || !$setup.collapsedDatasets.has(group.dataset))
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(group.requests, (req) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: req.id,
                              "data-help-id": req.id,
                              class: _normalizeClass(["nge-cl-help-item", {
                  'nge-cl-help-item--active': $setup.activeHelpId === req.id,
                  'nge-cl-help-item--cross': !group.isCurrent,
                }])
                            }, [
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, [
                                  _hoisted_84,
                                  _createElementVNode("div", _hoisted_85, [
                                    _createElementVNode("div", {
                                      class: "nge-cl-row-name",
                                      onClick: $event => ($setup.copyId(req.segId)),
                                      title: 'Click to copy ' + req.segId
                                    }, [
                                      _createTextVNode(_toDisplayString(req.segId) + " ", 1 /* TEXT */),
                                      ($setup.copiedId === req.segId)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_87, "copied"))
                                        : _createCommentVNode("v-if", true)
                                    ], 8 /* PROPS */, _hoisted_86),
                                    _createElementVNode("div", _hoisted_88, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["nge-cl-badge nge-cl-status--help", { 'nge-cl-badge--live': $setup.isLiveHelp(req) }])
                                      }, _toDisplayString($setup.isLiveHelp(req) ? '🤝 ' + req.issueType : req.issueType), 3 /* TEXT, CLASS */),
                                      (req.userName)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_89, "by " + _toDisplayString(req.userName), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("span", _hoisted_90, _toDisplayString($setup.relativeTime(req.createdAt)), 1 /* TEXT */)
                                    ]),
                                    (req.note)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["nge-cl-help-note", { 'nge-cl-help-note--expanded': $setup.expandedNotes.has(req.id) }]),
                                          onClick: $event => ($setup.toggleNoteExpand(req.id))
                                        }, _toDisplayString(req.note), 11 /* TEXT, CLASS, PROPS */, _hoisted_91))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" A long note shows two lines; say it opens (Ames 2026-10-21). "),
                                    (req.note && $setup.noteIsLong(req.note))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "nge-cl-help-note-more",
                                          onClick: $event => ($setup.toggleNoteExpand(req.id))
                                        }, _toDisplayString($setup.expandedNotes.has(req.id) ? 'Show less' : 'Show more'), 9 /* TEXT, PROPS */, _hoisted_92))
                                      : _createCommentVNode("v-if", true),
                                    (req.viewUrl)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 2,
                                          class: "nge-cl-response-link",
                                          href: "#",
                                          onClick: _withModifiers($event => ($setup.openResponseUrl(req.viewUrl)), ["prevent"]),
                                          title: "Load the view they were looking at"
                                        }, "↗ Open their view", 8 /* PROPS */, _hoisted_93))
                                      : _createCommentVNode("v-if", true),
                                    (req.annotationLayer)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 3,
                                          class: "nge-cl-response-layer",
                                          title: req.viewUrl ? 'Their marks are in this annotation layer. Open their view to see it.' : 'They pointed at this annotation layer, but this request did not save their view.'
                                        }, "📐 " + _toDisplayString(req.annotationLayer === 'All annotation layers' ? req.annotationLayer : (req.annotationLayer.includes(', ') ? 'Layers: ' : 'Layer: ') + req.annotationLayer), 9 /* TEXT, PROPS */, _hoisted_94))
                                      : _createCommentVNode("v-if", true),
                                    (req.screenshotUrl)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 4,
                                          href: req.screenshotUrl,
                                          target: "_blank",
                                          rel: "noopener",
                                          class: "nge-cl-help-shot-thumb",
                                          title: 'Open full screenshot'
                                        }, [
                                          _createElementVNode("img", {
                                            src: req.screenshotUrl,
                                            alt: "Help screenshot"
                                          }, null, 8 /* PROPS */, _hoisted_96)
                                        ], 8 /* PROPS */, _hoisted_95))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_97, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["nge-cl-btn nge-cl-btn--jump nge-cl-btn--popout", { 'nge-cl-btn--jump-active': $setup.poppedHelpId === req.id }]),
                                    title: "Open this request in its own window, easy to read",
                                    "aria-label": "Open in its own window",
                                    onClick: $event => ($setup.popOutReq(req))
                                  }, "⧉", 10 /* CLASS, PROPS */, _hoisted_98),
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn nge-cl-btn--jump",
                                    onClick: $event => ($setup.jumpToReq(req)),
                                    title: !group.isCurrent ? `Switch to ${group.label} and jump` : 'Jump to segment'
                                  }, "↗", 8 /* PROPS */, _hoisted_99),
                                  _createCommentVNode(" Mentor mode: offer to join the asker's view. They accept or decline. "),
                                  ($setup.teamAllowed && $setup.isLiveHelp(req) && req.userId && req.userId !== $setup.backend.userId)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "nge-cl-btn nge-cl-btn--join",
                                        disabled: $setup.offeredTo.has(req.id),
                                        title: $setup.offeredTo.has(req.id) ? 'Offer sent. Waiting for them to accept.' : `Offer to join ${req.userName || 'their'} view and help, live. They choose whether to accept.`,
                                        onClick: $event => ($setup.offerToJoin(req))
                                      }, _toDisplayString($setup.offeredTo.has(req.id) ? 'Offered' : 'Join'), 9 /* TEXT, PROPS */, _hoisted_100))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("button", {
                                    class: "nge-cl-btn nge-cl-btn--respond",
                                    onClick: $event => ($setup.toggleResponseForm(req.id)),
                                    title: $setup.respondingTo === req.id ? 'Cancel' : 'Respond'
                                  }, _toDisplayString($setup.respondingTo === req.id ? '▾' : '💬'), 9 /* TEXT, PROPS */, _hoisted_101),
                                  _createCommentVNode(" Only the player who asked, or an admin, closes a request; the\n                         bare \"Resolve\" read as something everyone should press (Ames 2026-10-21). "),
                                  ($setup.canResolve(req))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "nge-cl-btn nge-cl-btn--complete",
                                        onClick: $event => ($setup.resolveReq(req)),
                                        title: req.userId === $setup.backend.userId ? 'Your question is answered: move it to Resolved for everyone' : 'Close this request for everyone: it moves to Resolved'
                                      }, "Mark solved", 8 /* PROPS */, _hoisted_102))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]),
                              _createCommentVNode(" Reply thread: one entry per help_responses row (each keeps its\n                 own link / annotation layer / screenshot). "),
                              (req.responses && req.responses.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(req.responses, (resp) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: resp.id,
                                        class: "nge-cl-response-item"
                                      }, [
                                        _createElementVNode("div", _hoisted_104, [
                                          _createTextVNode("💬 " + _toDisplayString(resp.userName || 'Response'), 1 /* TEXT */),
                                          (resp.resolved)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_105, " · resolved"))
                                            : _createCommentVNode("v-if", true),
                                          _createTextVNode(":")
                                        ]),
                                        (resp.note)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString(resp.note), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        (resp.url)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 1,
                                              class: "nge-cl-response-link",
                                              onClick: _withModifiers($event => ($setup.openResponseUrl(resp.url)), ["prevent"]),
                                              href: "#"
                                            }, "↗ View linked state", 8 /* PROPS */, _hoisted_107))
                                          : _createCommentVNode("v-if", true),
                                        (resp.annotationLayer)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_108, "📐 Layer: " + _toDisplayString(resp.annotationLayer), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        (resp.screenshotUrl)
                                          ? (_openBlock(), _createElementBlock("a", {
                                              key: 3,
                                              href: resp.screenshotUrl,
                                              target: "_blank",
                                              rel: "noopener",
                                              class: "nge-cl-help-shot-thumb",
                                              title: "Open full screenshot"
                                            }, [
                                              _createElementVNode("img", {
                                                src: resp.screenshotUrl,
                                                alt: "Reply screenshot"
                                              }, null, 8 /* PROPS */, _hoisted_110)
                                            ], 8 /* PROPS */, _hoisted_109))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    ($setup.respondingTo !== req.id)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "nge-cl-btn nge-cl-btn--reply",
                                          onClick: $event => ($setup.toggleResponseForm(req.id))
                                        }, "↩ Reply", 8 /* PROPS */, _hoisted_111))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _createCommentVNode(" Inline response form (below existing thread) "),
                              ($setup.respondingTo === req.id && $setup.poppedHelpId !== req.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => (($setup.responseNote) = $event)),
                                      placeholder: "Write your response... (Enter to submit, Shift+Enter for newline)",
                                      class: "nge-cl-response-textarea",
                                      rows: "3",
                                      onKeydown: [
                                        _cache[54] || (_cache[54] = _withModifiers(() => {}, ["stop"])),
                                        _withKeys(_withModifiers($event => ($setup.submitResponse(req)), ["exact","prevent"]), ["enter"])
                                      ],
                                      onKeyup: _cache[55] || (_cache[55] = _withModifiers(() => {}, ["stop"])),
                                      onKeypress: _cache[56] || (_cache[56] = _withModifiers(() => {}, ["stop"]))
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_113), [
                                      [_vModelText, $setup.responseNote]
                                    ]),
                                    _createElementVNode("div", _hoisted_114, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => (($setup.responseUrl) = $event)),
                                        placeholder: "Neuroglancer state URL (optional)",
                                        class: "nge-cl-response-input",
                                        onKeydown: _cache[58] || (_cache[58] = _withModifiers(() => {}, ["stop"])),
                                        onKeyup: _cache[59] || (_cache[59] = _withModifiers(() => {}, ["stop"])),
                                        onKeypress: _cache[60] || (_cache[60] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                        [_vModelText, $setup.responseUrl]
                                      ]),
                                      _createElementVNode("button", {
                                        class: "nge-cl-btn nge-cl-btn--copy-state",
                                        onClick: $setup.copyCurrentState,
                                        title: "Copy current viewer state URL"
                                      }, "📋 State")
                                    ]),
                                    ($setup.getAnnotationLayers().length > 0)
                                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                          key: 0,
                                          "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => (($setup.responseAnnotationLayer) = $event)),
                                          class: "nge-cl-response-input"
                                        }, [
                                          _hoisted_115,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAnnotationLayers(), (layer) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: layer,
                                              value: layer
                                            }, _toDisplayString(layer), 9 /* TEXT, PROPS */, _hoisted_116))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ], 512 /* NEED_PATCH */)), [
                                          [_vModelSelect, $setup.responseAnnotationLayer]
                                        ])
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" Attach an (optionally annotated) screenshot to the reply,\n                   same flow as the initial request. "),
                                    (!$setup.responseScreenshotUrl)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "nge-cl-btn nge-cl-help-shot-btn",
                                          onClick: _cache[62] || (_cache[62] = $event => ($setup.showResponseScreenshotDialog = true)),
                                          title: "Attach a screenshot of the current view"
                                        }, "📷 Attach screenshot"))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                          _createElementVNode("img", {
                                            src: $setup.responseScreenshotUrl,
                                            alt: "Reply screenshot"
                                          }, null, 8 /* PROPS */, _hoisted_118),
                                          _createElementVNode("button", {
                                            class: "nge-cl-help-shot-remove",
                                            onClick: $setup.clearResponseScreenshot,
                                            title: "Remove screenshot"
                                          }, "×")
                                        ])),
                                    _createElementVNode("button", {
                                      class: "nge-cl-btn nge-cl-btn--submit-response",
                                      disabled: !$setup.responseNote.trim() && !$setup.responseScreenshotUrl,
                                      onClick: $event => ($setup.submitResponse(req))
                                    }, "Submit Response", 8 /* PROPS */, _hoisted_119),
                                    ($setup.canResolve(req))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 3,
                                          class: "nge-cl-btn nge-cl-btn--submit-response nge-cl-btn--resolve",
                                          disabled: !$setup.responseNote.trim() && !$setup.responseScreenshotUrl,
                                          title: "Send the reply and move the request to Resolved for everyone",
                                          onClick: $event => ($setup.submitResponse(req, true))
                                        }, "Reply and mark solved", 8 /* PROPS */, _hoisted_120))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 10 /* CLASS, PROPS */, _hoisted_81))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createCommentVNode(" Resolved section "),
                  ($setup.resolvedHelp.length > 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 7,
                        class: "nge-cl-help-resolved-header",
                        onClick: _cache[63] || (_cache[63] = $event => ($setup.showResolved = !$setup.showResolved))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["nge-cl-help-resolved-arrow", { 'nge-cl-help-resolved-arrow--open': $setup.showResolved }])
                        }, "▸", 2 /* CLASS */),
                        _createTextVNode(" Resolved (" + _toDisplayString($setup.resolvedHelp.length) + ") ", 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.showResolved)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 8 }, _renderList($setup.resolvedHelp, (req) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: req.id,
                          "data-help-id": req.id,
                          class: _normalizeClass(["nge-cl-help-item", { 'nge-cl-help-item--active': $setup.activeHelpId === req.id }])
                        }, [
                          _createElementVNode("div", _hoisted_122, [
                            _createElementVNode("div", _hoisted_123, [
                              _hoisted_124,
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("div", {
                                  class: "nge-cl-row-name",
                                  onClick: $event => ($setup.copyId(req.segId)),
                                  title: 'Click to copy ' + req.segId
                                }, _toDisplayString(req.segId), 9 /* TEXT, PROPS */, _hoisted_126),
                                _createElementVNode("div", _hoisted_127, [
                                  _createElementVNode("span", _hoisted_128, _toDisplayString(req.issueType), 1 /* TEXT */),
                                  (req.resolvedByName)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_129, "✓ " + _toDisplayString(req.resolvedByName), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("span", _hoisted_130, _toDisplayString($setup.relativeTime(req.createdAt)), 1 /* TEXT */)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_131, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["nge-cl-btn nge-cl-btn--jump nge-cl-btn--popout", { 'nge-cl-btn--jump-active': $setup.poppedHelpId === req.id }]),
                                title: "Open this request in its own window, easy to read",
                                "aria-label": "Open in its own window",
                                onClick: $event => ($setup.popOutReq(req))
                              }, "⧉", 10 /* CLASS, PROPS */, _hoisted_132),
                              _createElementVNode("button", {
                                class: "nge-cl-btn nge-cl-btn--jump",
                                onClick: $event => ($setup.jumpToReq(req)),
                                title: "Jump to segment"
                              }, "↗", 8 /* PROPS */, _hoisted_133),
                              _createElementVNode("button", {
                                class: "nge-cl-btn nge-cl-btn--release",
                                onClick: $event => ($setup.removeReq(req)),
                                title: "Remove"
                              }, "×", 8 /* PROPS */, _hoisted_134)
                            ])
                          ]),
                          _createCommentVNode(" Response display: one entry per help_responses row "),
                          (req.responses && req.responses.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(req.responses, (resp) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: resp.id,
                                    class: "nge-cl-response-item"
                                  }, [
                                    _createElementVNode("div", _hoisted_136, [
                                      _createTextVNode(_toDisplayString(resp.userName || 'Response'), 1 /* TEXT */),
                                      (resp.resolved)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_137, " · resolved"))
                                        : _createCommentVNode("v-if", true),
                                      _createTextVNode(":")
                                    ]),
                                    (resp.note)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(resp.note), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (resp.url)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          class: "nge-cl-response-link",
                                          onClick: _withModifiers($event => ($setup.openResponseUrl(resp.url)), ["prevent"]),
                                          href: "#"
                                        }, "↗ View linked state", 8 /* PROPS */, _hoisted_139))
                                      : _createCommentVNode("v-if", true),
                                    (resp.annotationLayer)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_140, "📐 Layer: " + _toDisplayString(resp.annotationLayer), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (resp.screenshotUrl)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 3,
                                          href: resp.screenshotUrl,
                                          target: "_blank",
                                          rel: "noopener",
                                          class: "nge-cl-help-shot-thumb",
                                          title: "Open full screenshot"
                                        }, [
                                          _createElementVNode("img", {
                                            src: resp.screenshotUrl,
                                            alt: "Reply screenshot"
                                          }, null, 8 /* PROPS */, _hoisted_142)
                                        ], 8 /* PROPS */, _hoisted_141))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 10 /* CLASS, PROPS */, _hoisted_121))
                      }), 128 /* KEYED_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" connectome.quest resources "),
                  _createElementVNode("div", _hoisted_143, [
                    _hoisted_144,
                    _createElementVNode("div", _hoisted_145, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.CONNECTOME_QUEST_RESOURCES, (res) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: res.id,
                          class: "nge-cl-quest-link",
                          href: res.url,
                          target: "_blank",
                          rel: "noopener",
                          title: res.description
                        }, [
                          _createElementVNode("span", _hoisted_147, _toDisplayString(res.icon), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_148, _toDisplayString(res.label), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_146))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
              : ($setup.filter === 'teams' && $setup.teamsHere)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createCommentVNode(" ═══ TEAMS TAB (saved teams: two to four players on one cell) ═══ "),
                    _createElementVNode("div", _hoisted_149, [
                      _createVNode($setup["TeamsTab"])
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : ($setup.filter === 'quests')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createCommentVNode(" ═══ QUESTS TAB (annotate a cell, apart from completing it) ═══ "),
                      _createElementVNode("div", _hoisted_150, [
                        ($setup.questsHere)
                          ? (_openBlock(), _createBlock($setup["AnnotationQuestsTab"], {
                              key: 0,
                              slim: $setup.slimQuest
                            }, null, 8 /* PROPS */, ["slim"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_151, [
                              _createElementVNode("div", _hoisted_152, [
                                _createTextVNode("Quests are on "),
                                _createElementVNode("b", null, _toDisplayString($setup.questDatasetName), 1 /* TEXT */),
                                _createTextVNode(" for now. You are on "),
                                _createElementVNode("b", null, _toDisplayString($setup.datasetDisplayName($setup.activeDataset || $setup.getCurrentDatasetName()) || 'another dataset'), 1 /* TEXT */),
                                _createTextVNode(".")
                              ]),
                              ($setup.questsLocked)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_153, "Unlock Level 1 (" + _toDisplayString($setup.questDatasetName) + ") to take them.", 1 /* TEXT */))
                                : ($setup.questDatasetEntry)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "nge-cl-btn nge-cl-btn--claim nge-cl-quests-switch",
                                      onClick: $setup.switchToQuestDataset,
                                      title: "Switch this view to the quests' dataset"
                                    }, "Switch to " + _toDisplayString($setup.questDatasetName), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                            ])),
                        ($setup.slimQuest)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "nge-cl-slim-expand",
                              title: "Full view",
                              "aria-label": "Full view",
                              onClick: $setup.expandAndStay
                            }, _hoisted_155))
                          : _createCommentVNode("v-if", true)
                      ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : ($setup.filter === 'cast' && $setup.castHere)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        _createCommentVNode(" ═══ CAST TAB (one example of each retinal cell type) ═══ "),
                        _createElementVNode("div", _hoisted_156, [
                          _createVNode($setup["RetinaCastTab"])
                        ])
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    : ($setup.filter === 'tags')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                          _createCommentVNode(" ═══ TAGS TAB (Scout tags: mergers / missing branches) ═══ "),
                          _createElementVNode("div", _hoisted_157, [
                            _createElementVNode("div", _hoisted_158, [
                              _createElementVNode("div", _hoisted_159, [
                                _createElementVNode("span", {
                                  class: "nge-cl-tag-pin",
                                  innerHTML: $setup.tagPinSvg
                                }, null, 8 /* PROPS */, _hoisted_160),
                                _createTextVNode(" Scout tags")
                              ]),
                              _createElementVNode("div", _hoisted_161, [
                                _createTextVNode(" Drop tags with the "),
                                _createElementVNode("span", {
                                  class: "nge-cl-tag-pin",
                                  innerHTML: $setup.tagPinSvg
                                }, null, 8 /* PROPS */, _hoisted_162),
                                _createTextVNode(" Tag Mode toolbar button: center the crosshair on a merger or a suspected missing branch and pick the type. Scythes jump to each open tag from here, fix it, and mark it resolved. ")
                              ])
                            ]),
                            _createCommentVNode(" Two separate questions, two rows (Amy: \"are all these my current\n               dataset? The 16 are in other dataset or is other a category?\").\n               Row 1 is WHERE: this dataset or every dataset. Row 2 is WHAT:\n               tag type, counted within the chosen scope. "),
                            _createCommentVNode(" The old \"Show tags on the map\" switch is gone: tag layers exist\n               only while Scout Tag mode is open (Amy 2026-09-28). "),
                            _hoisted_163,
                            _createElementVNode("div", _hoisted_164, [
                              _hoisted_165,
                              _createElementVNode("button", {
                                class: _normalizeClass({ 'nge-cl-lane--active': !$setup.showAllDatasetTags }),
                                onClick: _cache[64] || (_cache[64] = $event => ($setup.showAllDatasetTags = false)),
                                title: "Open tags on the dataset you are viewing"
                              }, _toDisplayString($setup.datasetDisplayName($setup.activeDataset) || 'This dataset') + " (" + _toDisplayString($setup.thisDatasetOpenTagCount) + ")", 3 /* TEXT, CLASS */),
                              _createElementVNode("button", {
                                class: _normalizeClass({ 'nge-cl-lane--active': $setup.showAllDatasetTags }),
                                onClick: _cache[65] || (_cache[65] = $event => ($setup.showAllDatasetTags = true)),
                                title: "Open tags on every dataset, including this one"
                              }, "🌐 All datasets (" + _toDisplayString($setup.humanOpenTags.length) + ")", 3 /* TEXT, CLASS */)
                            ]),
                            _createElementVNode("div", _hoisted_166, [
                              _hoisted_167,
                              _createElementVNode("button", {
                                class: _normalizeClass({ 'nge-cl-lane--active': $setup.tagLane === 'all' }),
                                onClick: _cache[66] || (_cache[66] = $event => ($setup.tagLane = 'all'))
                              }, "Any (" + _toDisplayString($setup.datasetTags.length) + ")", 3 /* TEXT, CLASS */),
                              _createElementVNode("button", {
                                class: _normalizeClass({ 'nge-cl-lane--active': $setup.tagLane === 'merger' }),
                                onClick: _cache[67] || (_cache[67] = $event => ($setup.tagLane = 'merger'))
                              }, [
                                _createElementVNode("img", {
                                  src: $setup.scytheIcon,
                                  class: "nge-cl-lane-icon",
                                  alt: ""
                                }, null, 8 /* PROPS */, _hoisted_168),
                                _createTextVNode(" For Scythes (" + _toDisplayString($setup.laneCount('merger')) + ")", 1 /* TEXT */)
                              ], 2 /* CLASS */),
                              _createElementVNode("button", {
                                class: _normalizeClass({ 'nge-cl-lane--active': $setup.tagLane === 'missing_branch' }),
                                onClick: _cache[68] || (_cache[68] = $event => ($setup.tagLane = 'missing_branch'))
                              }, [
                                _createElementVNode("img", {
                                  src: $setup.tracerIcon,
                                  class: "nge-cl-lane-icon",
                                  alt: ""
                                }, null, 8 /* PROPS */, _hoisted_169),
                                _createTextVNode(" For Tracers (" + _toDisplayString($setup.laneCount('missing_branch')) + ")", 1 /* TEXT */)
                              ], 2 /* CLASS */)
                            ]),
                            (!$setup.laneFilteredTags.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_170, " No open tags in this lane. The volume is momentarily unsuspicious. "))
                              : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.laneFilteredTags, (tag, tagIdx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: tag.id,
                                class: "nge-cl-help-item nge-cl-tag-card",
                                style: _normalizeStyle({ '--tag-color': $setup.TAG_TYPE_META[tag.tagType]?.pip ?? '#889' })
                              }, [
                                _createElementVNode("div", _hoisted_171, [
                                  _createElementVNode("div", _hoisted_172, [
                                    _createElementVNode("span", {
                                      class: "nge-cl-pip",
                                      style: _normalizeStyle({ background: $setup.TAG_TYPE_META[tag.tagType]?.pip ?? '#889' })
                                    }, null, 4 /* STYLE */),
                                    _createElementVNode("div", _hoisted_173, [
                                      _createElementVNode("div", _hoisted_174, [
                                        _createTextVNode(_toDisplayString($setup.tagLabel(tag)) + " ", 1 /* TEXT */),
                                        (tag.segId)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_175, " · seg …" + _toDisplayString(tag.segId.slice(-6)), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_176, [
                                        _createElementVNode("span", _hoisted_177, _toDisplayString(tag.position.join(', ')), 1 /* TEXT */),
                                        ($setup.isCrossDatasetTag(tag))
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_178, _toDisplayString($setup.datasetDisplayName(tag.dataset)), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        _createElementVNode("span", _hoisted_179, _toDisplayString(tag.userName || 'Anonymous') + " · " + _toDisplayString($setup.relativeTime(tag.createdAt)), 1 /* TEXT */)
                                      ]),
                                      (tag.note)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_180, _toDisplayString(tag.note), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      (tag.annotationLayer)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_181, "📐 " + _toDisplayString(tag.annotationLayer), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      (tag.screenshotUrl)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 2,
                                            href: tag.screenshotUrl,
                                            target: "_blank",
                                            rel: "noopener",
                                            class: "nge-cl-help-shot-thumb",
                                            title: "Open full screenshot"
                                          }, [
                                            _createElementVNode("img", {
                                              src: tag.screenshotUrl,
                                              alt: "Tag screenshot"
                                            }, null, 8 /* PROPS */, _hoisted_183)
                                          ], 8 /* PROPS */, _hoisted_182))
                                        : _createCommentVNode("v-if", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_184, [
                                    _createElementVNode("span", _hoisted_185, [
                                      ($setup.orbitOn(tagIdx, $setup.laneFilteredTags.length))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_186))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("button", {
                                        class: "nge-cl-btn nge-cl-btn--jump",
                                        onClick: $event => ($setup.jumpToTag(tag)),
                                        title: $setup.isCrossDatasetTag(tag) ? 'Switch to ' + $setup.datasetHeading(tag.dataset) + ' and jump' : 'Jump to location'
                                      }, "↗", 8 /* PROPS */, _hoisted_187)
                                    ]),
                                    _createElementVNode("button", {
                                      class: "nge-cl-btn nge-cl-btn--complete nge-cl-btn--tagdone",
                                      onClick: $event => ($setup.resolveTagFun(tag, $event)),
                                      title: "I fixed this! Claim the tag"
                                    }, "✓", 8 /* PROPS */, _hoisted_188),
                                    ($setup.confirmDeleteTagId === tag.id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn nge-cl-btn--confirmdel",
                                            onClick: $event => ($setup.confirmDeleteTag(tag)),
                                            title: "Yes, delete this tag for everyone"
                                          }, "Delete?", 8 /* PROPS */, _hoisted_189),
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn",
                                            onClick: _cache[69] || (_cache[69] = $event => ($setup.confirmDeleteTagId = null)),
                                            title: "Keep the tag"
                                          }, "✕")
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "nge-cl-btn nge-cl-btn--release",
                                          onClick: $event => ($setup.askDeleteTag(tag)),
                                          title: "Delete this tag for everyone (use ✓ if it was fixed)"
                                        }, "🗑", 8 /* PROPS */, _hoisted_190))
                                  ])
                                ])
                              ], 4 /* STYLE */))
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createElementVNode("div", {
                              class: "nge-cl-help-resolved-toggle",
                              onClick: _cache[70] || (_cache[70] = $event => ($setup.showResolvedTags = !$setup.showResolvedTags))
                            }, _toDisplayString($setup.showResolvedTags ? '▾' : '▸') + " Resolved (" + _toDisplayString($setup.resolvedTags.length) + ") ", 1 /* TEXT */),
                            ($setup.showResolvedTags)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.resolvedTags, (tag) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: tag.id,
                                    class: "nge-cl-help-item"
                                  }, [
                                    _createElementVNode("div", _hoisted_191, [
                                      _createElementVNode("div", _hoisted_192, [
                                        _hoisted_193,
                                        _createElementVNode("div", _hoisted_194, [
                                          _createElementVNode("div", _hoisted_195, _toDisplayString($setup.tagLabel(tag)), 1 /* TEXT */),
                                          _createElementVNode("div", _hoisted_196, [
                                            (tag.resolvedByName)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_197, "✓ " + _toDisplayString(tag.resolvedByName), 1 /* TEXT */))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("span", _hoisted_198, _toDisplayString($setup.relativeTime(tag.createdAt)), 1 /* TEXT */)
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_199, [
                                        ($setup.confirmDeleteTagId === tag.id)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createElementVNode("button", {
                                                class: "nge-cl-btn nge-cl-btn--confirmdel",
                                                onClick: $event => ($setup.confirmDeleteTag(tag)),
                                                title: "Yes, delete this tag for everyone"
                                              }, "Delete?", 8 /* PROPS */, _hoisted_200),
                                              _createElementVNode("button", {
                                                class: "nge-cl-btn",
                                                onClick: _cache[71] || (_cache[71] = $event => ($setup.confirmDeleteTagId = null)),
                                                title: "Keep the tag"
                                              }, "✕")
                                            ], 64 /* STABLE_FRAGMENT */))
                                          : (_openBlock(), _createElementBlock("button", {
                                              key: 1,
                                              class: "nge-cl-btn nge-cl-btn--release",
                                              onClick: $event => ($setup.askDeleteTag(tag)),
                                              title: "Delete this tag for everyone"
                                            }, "🗑", 8 /* PROPS */, _hoisted_201))
                                      ])
                                    ])
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                      : ($setup.filter === 'ai')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                            _createCommentVNode(" ═══ AI TAB (model-detected merge-error candidates) ═══ "),
                            _createElementVNode("div", _hoisted_202, [
                              _hoisted_203,
                              _createElementVNode("div", _hoisted_204, [
                                _createElementVNode("span", _hoisted_205, _toDisplayString($setup.aiDatasetTags.length) + " candidates on " + _toDisplayString($setup.aiGroups.length) + " " + _toDisplayString($setup.aiGroups.length === 1 ? 'cell' : 'cells'), 1 /* TEXT */),
                                _createElementVNode("button", {
                                  class: _normalizeClass({ 'nge-cl-lane--active': $setup.tagStore.aiLayerOn }),
                                  title: $setup.tagStore.aiLayerOn ? 'Hide AI candidate markers in the viewer' : 'Show AI candidate markers in the viewer',
                                  onClick: _cache[72] || (_cache[72] = $event => ($setup.tagStore.setAiLayerOn(!$setup.tagStore.aiLayerOn)))
                                }, "📍 Markers", 10 /* CLASS, PROPS */, _hoisted_206)
                              ]),
                              (!$setup.aiDatasetTags.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                                    _createTextVNode(" No open AI candidates for this dataset. "),
                                    (!$setup.aiElsewhere.length)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" The model finds no fault here.")
                                        ], 64 /* STABLE_FRAGMENT */))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (!$setup.aiDatasetTags.length && $setup.aiElsewhere.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.aiElsewhere, (e) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: e.ds.id,
                                        class: "nge-cl-lane--active",
                                        title: 'Switch the viewer to ' + e.ds.label,
                                        onClick: $event => ($setup.switchToAiDataset(e.ds))
                                      }, _toDisplayString($setup.SPECIES_ICONS[e.ds.species]) + " Switch to " + _toDisplayString(e.ds.shortLabel) + " (" + _toDisplayString(e.count) + " candidates) ", 9 /* TEXT, PROPS */, _hoisted_209))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.aiGroups, (g) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: g.root
                                }, [
                                  _createElementVNode("div", {
                                    class: "nge-cl-ai-group",
                                    onClick: $event => ($setup.toggleAiGroup(g.root)),
                                    title: $setup.aiGroupExpanded(g.root) ? 'Collapse this cell' : 'Expand this cell'
                                  }, [
                                    _createElementVNode("span", _hoisted_211, _toDisplayString($setup.aiGroupExpanded(g.root) ? '▾' : '▸'), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_212, "🧠 Cell …" + _toDisplayString(g.root.slice(-6)), 1 /* TEXT */),
                                    _createElementVNode("span", _hoisted_213, _toDisplayString(g.tags.length) + " " + _toDisplayString(g.tags.length === 1 ? 'candidate' : 'candidates'), 1 /* TEXT */),
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["nge-cl-ai-group-heat", { 'nge-cl-lane--active': $setup.tagStore.activeHeatRoots.includes(g.root) }]),
                                      disabled: $setup.tagStore.heatLoadingRoot === g.root,
                                      title: "Heat layer: every window the model scored on this cell, cool to hot",
                                      onClick: _withModifiers($event => ($setup.tagStore.toggleHeatLayer(g.root)), ["stop"])
                                    }, _toDisplayString($setup.tagStore.heatLoadingRoot === g.root ? '⏳' : '🔥') + " Heat ", 11 /* TEXT, CLASS, PROPS */, _hoisted_214)
                                  ], 8 /* PROPS */, _hoisted_210),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.tags, (tag, tagIdx) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                      key: tag.id,
                                      class: "nge-cl-help-item"
                                    }, [
                                      _createElementVNode("div", _hoisted_215, [
                                        _createElementVNode("div", _hoisted_216, [
                                          _createElementVNode("span", {
                                            class: "nge-cl-pip",
                                            style: _normalizeStyle({ background: $setup.confColor(tag.confidence) })
                                          }, null, 4 /* STYLE */),
                                          _createElementVNode("div", _hoisted_217, [
                                            _createElementVNode("div", _hoisted_218, [
                                              _createTextVNode(_toDisplayString($setup.aiCategoryIcon(tag)) + " Cut ", 1 /* TEXT */),
                                              _createElementVNode("span", {
                                                class: "nge-cl-ai-conf",
                                                style: _normalizeStyle({ color: $setup.confColor(tag.confidence) })
                                              }, _toDisplayString(Math.round((tag.confidence ?? 0) * 100)) + "%", 5 /* TEXT, STYLE */),
                                              (tag.segId)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_219, " · seg …" + _toDisplayString(tag.segId.slice(-6)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_220, [
                                              _createElementVNode("span", _hoisted_221, _toDisplayString(tag.position.join(', ')), 1 /* TEXT */),
                                              ($setup.isCrossDatasetTag(tag))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_222, _toDisplayString($setup.datasetDisplayName(tag.dataset)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_223, [
                                          _createElementVNode("span", _hoisted_224, [
                                            ($setup.orbitOn(tagIdx, g.tags.length))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_225))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("button", {
                                              class: "nge-cl-btn nge-cl-btn--jump",
                                              onClick: $event => ($setup.jumpToAiTag(tag)),
                                              disabled: $setup.isCrossDatasetTag(tag),
                                              title: $setup.isCrossDatasetTag(tag) ? 'Switch to ' + $setup.datasetDisplayName(tag.dataset) + ' first' : 'Jump to location and preview the proposed split'
                                            }, "↗", 8 /* PROPS */, _hoisted_226)
                                          ]),
                                          _createElementVNode("button", {
                                            class: _normalizeClass(["nge-cl-btn nge-cl-btn--split", { 'nge-cl-btn--split-active': $setup.tagStore.activeSplitTagId === tag.id }]),
                                            disabled: !tag.modelData?.posRelUm?.length,
                                            title: "Toggle the model's proposed split overlay",
                                            onClick: $event => ($setup.tagStore.toggleSplitOverlay(tag))
                                          }, "✂", 10 /* CLASS, PROPS */, _hoisted_227),
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn nge-cl-btn--complete nge-cl-btn--tagdone",
                                            onClick: $event => ($setup.resolveTagFun(tag, $event)),
                                            title: "I fixed this! Claim the tag"
                                          }, "✓", 8 /* PROPS */, _hoisted_228),
                                          ($setup.confirmDeleteTagId === tag.id)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createElementVNode("button", {
                                                  class: "nge-cl-btn nge-cl-btn--confirmdel",
                                                  onClick: $event => ($setup.confirmDeleteTag(tag)),
                                                  title: "Yes, delete this candidate for everyone"
                                                }, "Delete?", 8 /* PROPS */, _hoisted_229),
                                                _createElementVNode("button", {
                                                  class: "nge-cl-btn",
                                                  onClick: _cache[73] || (_cache[73] = $event => ($setup.confirmDeleteTagId = null)),
                                                  title: "Keep the candidate"
                                                }, "✕")
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "nge-cl-btn nge-cl-btn--release",
                                                onClick: $event => ($setup.askDeleteTag(tag)),
                                                title: "Delete this candidate for everyone (use ✓ if it was fixed)"
                                              }, "🗑", 8 /* PROPS */, _hoisted_230))
                                        ])
                                      ])
                                    ])), [
                                      [_vShow, $setup.aiGroupExpanded(g.root)]
                                    ])
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 128 /* KEYED_FRAGMENT */)),
                              _createElementVNode("div", {
                                class: "nge-cl-help-resolved-toggle",
                                onClick: _cache[74] || (_cache[74] = $event => ($setup.showResolvedAiTags = !$setup.showResolvedAiTags))
                              }, _toDisplayString($setup.showResolvedAiTags ? '▾' : '▸') + " Resolved (" + _toDisplayString($setup.aiResolvedTags.length) + ") ", 1 /* TEXT */),
                              ($setup.showResolvedAiTags)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($setup.aiResolvedTags, (tag) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: tag.id,
                                      class: "nge-cl-help-item"
                                    }, [
                                      _createElementVNode("div", _hoisted_231, [
                                        _createElementVNode("div", _hoisted_232, [
                                          _hoisted_233,
                                          _createElementVNode("div", _hoisted_234, [
                                            _createElementVNode("div", _hoisted_235, _toDisplayString($setup.aiCategoryIcon(tag)) + " Cut · " + _toDisplayString(Math.round((tag.confidence ?? 0) * 100)) + "%", 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_236, [
                                              (tag.resolvedByName)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_237, "✓ " + _toDisplayString(tag.resolvedByName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                              _createElementVNode("span", _hoisted_238, _toDisplayString($setup.relativeTime(tag.createdAt)), 1 /* TEXT */)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_239, [
                                          ($setup.confirmDeleteTagId === tag.id)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createElementVNode("button", {
                                                  class: "nge-cl-btn nge-cl-btn--confirmdel",
                                                  onClick: $event => ($setup.confirmDeleteTag(tag)),
                                                  title: "Yes, delete this candidate for everyone"
                                                }, "Delete?", 8 /* PROPS */, _hoisted_240),
                                                _createElementVNode("button", {
                                                  class: "nge-cl-btn",
                                                  onClick: _cache[75] || (_cache[75] = $event => ($setup.confirmDeleteTagId = null)),
                                                  title: "Keep the candidate"
                                                }, "✕")
                                              ], 64 /* STABLE_FRAGMENT */))
                                            : (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "nge-cl-btn nge-cl-btn--release",
                                                onClick: $event => ($setup.askDeleteTag(tag)),
                                                title: "Delete this candidate for everyone"
                                              }, "🗑", 8 /* PROPS */, _hoisted_241))
                                        ])
                                      ])
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                : _createCommentVNode("v-if", true)
                            ])
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                        : ($setup.filter === 'links')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                              _createCommentVNode(" ═══ LINKS TAB ═══ "),
                              _createElementVNode("div", _hoisted_242, [
                                _createCommentVNode(" Save current view form "),
                                _createVNode(_Transition, { name: "nge-slide" }, {
                                  default: _withCtx(() => [
                                    ($setup.showSaveLinkForm)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
                                          _hoisted_244,
                                          _hoisted_245,
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => (($setup.newLinkTitle) = $event)),
                                            class: "nge-cl-search-input",
                                            placeholder: "Title (e.g. 'Tricky merge near soma')",
                                            onKeydown: [
                                              _cache[77] || (_cache[77] = _withModifiers(() => {}, ["stop"])),
                                              _withKeys(_withModifiers($setup.submitNewLink, ["exact","prevent"]), ["enter"])
                                            ],
                                            onKeyup: _cache[78] || (_cache[78] = _withModifiers(() => {}, ["stop"])),
                                            onKeypress: _cache[79] || (_cache[79] = _withModifiers(() => {}, ["stop"]))
                                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_246), [
                                            [_vModelText, $setup.newLinkTitle]
                                          ]),
                                          _withDirectives(_createElementVNode("textarea", {
                                            "onUpdate:modelValue": _cache[80] || (_cache[80] = $event => (($setup.newLinkNote) = $event)),
                                            class: "nge-cl-help-create-note",
                                            placeholder: "Optional note...",
                                            rows: "2",
                                            onKeydown: _cache[81] || (_cache[81] = _withModifiers(() => {}, ["stop"])),
                                            onKeyup: _cache[82] || (_cache[82] = _withModifiers(() => {}, ["stop"])),
                                            onKeypress: _cache[83] || (_cache[83] = _withModifiers(() => {}, ["stop"]))
                                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                            [_vModelText, $setup.newLinkNote]
                                          ]),
                                          _createElementVNode("label", _hoisted_247, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "checkbox",
                                              "onUpdate:modelValue": _cache[84] || (_cache[84] = $event => (($setup.newLinkPublic) = $event))
                                            }, null, 512 /* NEED_PATCH */), [
                                              [_vModelCheckbox, $setup.newLinkPublic]
                                            ]),
                                            _createTextVNode(" Make public (anyone in the lab can see) ")
                                          ]),
                                          _createCommentVNode(" Optional picture of the view (Amy 2026-09-28), same capture\n                   and pen dialog as help requests. "),
                                          ($setup.newLinkScreenshotUrl)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                                                _createElementVNode("img", {
                                                  src: $setup.newLinkScreenshotUrl,
                                                  alt: "Attached screenshot"
                                                }, null, 8 /* PROPS */, _hoisted_249),
                                                _createElementVNode("button", {
                                                  class: "nge-cl-help-shot-remove",
                                                  onClick: _cache[85] || (_cache[85] = $event => ($setup.newLinkScreenshotUrl = '')),
                                                  title: "Remove screenshot"
                                                }, "×")
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          _createElementVNode("div", _hoisted_250, [
                                            (!$setup.newLinkScreenshotUrl)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "nge-cl-help-create-cancel",
                                                  onClick: _cache[86] || (_cache[86] = $event => ($setup.showLinkScreenshotDialog = true)),
                                                  title: "Attach a screenshot of the current view"
                                                }, "📸 Screenshot"))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("button", {
                                              class: "nge-cl-help-create-submit",
                                              onClick: $setup.submitNewLink
                                            }, "💾 Save Link"),
                                            _createElementVNode("button", {
                                              class: "nge-cl-help-create-cancel",
                                              onClick: _cache[87] || (_cache[87] = $event => ($setup.showSaveLinkForm = false))
                                            }, "Cancel")
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createCommentVNode(" Ownership filter chips + Save new "),
                                _createElementVNode("div", _hoisted_251, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["nge-cl-link-save-new", { active: $setup.showSaveLinkForm }]),
                                    onClick: _cache[88] || (_cache[88] = $event => ($setup.showSaveLinkForm = !$setup.showSaveLinkForm)),
                                    title: "Save the current view as a working link"
                                  }, "+ Save new", 2 /* CLASS */),
                                  _hoisted_252,
                                  _createElementVNode("button", {
                                    class: _normalizeClass({ active: $setup.linksOwnershipFilter === 'all' }),
                                    onClick: _cache[89] || (_cache[89] = $event => ($setup.linksOwnershipFilter = 'all'))
                                  }, "All", 2 /* CLASS */),
                                  _createElementVNode("button", {
                                    class: _normalizeClass({ active: $setup.linksOwnershipFilter === 'mine' }),
                                    onClick: _cache[90] || (_cache[90] = $event => ($setup.linksOwnershipFilter = 'mine'))
                                  }, "Mine", 2 /* CLASS */),
                                  _createElementVNode("button", {
                                    class: _normalizeClass({ active: $setup.linksOwnershipFilter === 'shared' }),
                                    onClick: _cache[91] || (_cache[91] = $event => ($setup.linksOwnershipFilter = 'shared'))
                                  }, "Shared", 2 /* CLASS */)
                                ]),
                                _createCommentVNode(" Empty state "),
                                ($setup.visibleLinks.length === 0 && !$setup.showSaveLinkForm)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_253, [
                                      _createTextVNode(" No saved links yet. Click "),
                                      _hoisted_254,
                                      _createTextVNode(" above to save the current view. ")
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _createCommentVNode(" Link rows "),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleLinks, (link) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: link.id,
                                    class: _normalizeClass(["nge-cl-help-item nge-cl-link-item", { 'nge-cl-link-item--starred': link.starred }])
                                  }, [
                                    _createElementVNode("div", _hoisted_255, [
                                      _createElementVNode("div", _hoisted_256, [
                                        _createElementVNode("span", {
                                          class: "nge-cl-pip",
                                          style: _normalizeStyle({ background: link.starred ? '#f5d142' : '#557' })
                                        }, null, 4 /* STYLE */),
                                        _createElementVNode("div", _hoisted_257, [
                                          ($setup.renamingLinkId === link.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_258, [
                                                _withDirectives(_createElementVNode("input", {
                                                  "onUpdate:modelValue": _cache[92] || (_cache[92] = $event => (($setup.renamingLinkValue) = $event)),
                                                  class: "nge-cl-search-input",
                                                  onKeydown: [
                                                    _cache[93] || (_cache[93] = _withModifiers(() => {}, ["stop"])),
                                                    _withKeys(_withModifiers($event => ($setup.commitRename(link)), ["exact","prevent"]), ["enter"])
                                                  ],
                                                  onKeyup: _cache[94] || (_cache[94] = _withModifiers(() => {}, ["stop"])),
                                                  onKeypress: _cache[95] || (_cache[95] = _withModifiers(() => {}, ["stop"])),
                                                  onBlur: $event => ($setup.commitRename(link)),
                                                  ref_for: true,
                                                  ref: "renameInput",
                                                  autofocus: ""
                                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_259), [
                                                  [_vModelText, $setup.renamingLinkValue]
                                                ])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: "nge-cl-row-name nge-cl-link-title",
                                                onDblclick: $event => ($setup.startRename(link)),
                                                title: 'Double-click to rename · ' + link.title
                                              }, _toDisplayString(link.title), 41 /* TEXT, PROPS, HYDRATE_EVENTS */, _hoisted_260)),
                                          _createElementVNode("div", _hoisted_261, [
                                            (link.dataset)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: "nge-cl-badge",
                                                  style: _normalizeStyle({ background: 'rgba(120,140,255,0.12)', color: '#abf' })
                                                }, _toDisplayString(link.dataset), 5 /* TEXT, STYLE */))
                                              : _createCommentVNode("v-if", true),
                                            (link.userId !== $setup.backend.userId && link.userName)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_262, "by " + _toDisplayString(link.userName), 1 /* TEXT */))
                                              : _createCommentVNode("v-if", true),
                                            (link.isPublic)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_263, "🌐 public"))
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("span", _hoisted_264, _toDisplayString($setup.relativeTimeShort(link.createdAt)), 1 /* TEXT */)
                                          ]),
                                          (link.note)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_265, _toDisplayString(link.note), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                          (link.screenshotUrl)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 3,
                                                href: link.screenshotUrl,
                                                target: "_blank",
                                                rel: "noopener",
                                                class: "nge-cl-help-shot-thumb",
                                                title: "Open full screenshot"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: link.screenshotUrl,
                                                  alt: "Screenshot of this view"
                                                }, null, 8 /* PROPS */, _hoisted_267)
                                              ], 8 /* PROPS */, _hoisted_266))
                                            : _createCommentVNode("v-if", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_268, [
                                        _createElementVNode("button", {
                                          class: "nge-cl-btn nge-cl-btn--jump",
                                          onClick: $event => ($setup.openLink(link)),
                                          title: "Open link in viewer"
                                        }, "↗", 8 /* PROPS */, _hoisted_269),
                                        _createElementVNode("button", {
                                          class: "nge-cl-btn",
                                          onClick: $event => ($setup.linksStore.toggleStar(link.id)),
                                          title: link.starred ? 'Unstar' : 'Star'
                                        }, _toDisplayString(link.starred ? '★' : '☆'), 9 /* TEXT, PROPS */, _hoisted_270),
                                        _createElementVNode("button", {
                                          class: "nge-cl-btn",
                                          onClick: $event => ($setup.startRename(link)),
                                          title: "Rename"
                                        }, "✏️", 8 /* PROPS */, _hoisted_271),
                                        _createElementVNode("button", {
                                          class: "nge-cl-btn",
                                          onClick: $event => ($setup.shareLinkToChat(link)),
                                          title: "Share to chat"
                                        }, "💬", 8 /* PROPS */, _hoisted_272),
                                        (link.userId === $setup.backend.userId)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "nge-cl-btn nge-cl-btn--release",
                                              onClick: $event => ($setup.linksStore.remove(link.id)),
                                              title: "Delete"
                                            }, "×", 8 /* PROPS */, _hoisted_273))
                                          : _createCommentVNode("v-if", true)
                                      ])
                                    ])
                                  ], 2 /* CLASS */))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                          : (($setup.loading || $setup.backend.loading) && $setup.cells.length === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                _createCommentVNode(" ═══ CELL TABS ═══ "),
                                _createCommentVNode(" Loading "),
                                _hoisted_274
                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            : ($setup.cells.length === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                                  _createCommentVNode(" Empty state "),
                                  _createElementVNode("div", _hoisted_275, [
                                    _hoisted_276,
                                    (!$setup.queue.sheetUrl)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_277, "Open Brain Quest first and load a quest sheet."))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                                  _createCommentVNode(" Cell list "),
                                  _createElementVNode("div", _hoisted_278, [
                                    _createCommentVNode(" Claim error banner "),
                                    ($setup.jumpError)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "nge-cl-error-banner",
                                          onClick: _cache[96] || (_cache[96] = $event => ($setup.jumpError = ''))
                                        }, _toDisplayString($setup.jumpError), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.chooseClaim)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_279, [
                                          _createElementVNode("div", _hoisted_280, [
                                            _createTextVNode(" Which of your claims did you finish? Click Complete on it below. "),
                                            _createElementVNode("span", {
                                              class: "nge-cl-error-dismiss",
                                              onClick: _cache[97] || (_cache[97] = $event => ($setup.chooseClaim = false))
                                            }, "×")
                                          ])
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.claimLimit)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_281, [
                                          _createElementVNode("div", _hoisted_282, [
                                            _createTextVNode(" You hold " + _toDisplayString($setup.claimLimit.length) + " claims, the most allowed. Release one to claim this cell. ", 1 /* TEXT */),
                                            _createElementVNode("span", {
                                              class: "nge-cl-error-dismiss",
                                              onClick: $setup.dismissClaimLimit
                                            }, "×")
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.claimLimit, (t) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: t.id,
                                              class: "nge-cl-limit-row"
                                            }, [
                                              _createElementVNode("span", null, _toDisplayString($setup.heldLabel(t)), 1 /* TEXT */),
                                              _createElementVNode("button", {
                                                class: "nge-cl-btn nge-cl-limit-release",
                                                disabled: $setup.releasing.has(String(t.id)),
                                                onClick: $event => ($setup.releaseHeld(t))
                                              }, [
                                                ($setup.releasing.has(String(t.id)))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_284))
                                                  : _createCommentVNode("v-if", true),
                                                _createTextVNode(_toDisplayString($setup.releasing.has(String(t.id)) ? 'Releasing…' : 'Release'), 1 /* TEXT */)
                                              ], 8 /* PROPS */, _hoisted_283)
                                            ]))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.claimError)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 3,
                                          class: "nge-cl-error-banner",
                                          onClick: _cache[98] || (_cache[98] = $event => ($setup.claimError = ''))
                                        }, [
                                          _createTextVNode(_toDisplayString($setup.claimError) + " ", 1 /* TEXT */),
                                          _hoisted_285
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.backend.loading && $setup.filter !== 'mine')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_286, _hoisted_288))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.filteredCells.length === 0 && $setup.filter === 'mine' && !$setup.slim)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_289, " No claimed cells yet. Claim cells from the All or Available tabs! "))
                                      : ($setup.filteredCells.length === 0 && $setup.filter === 'available' && !$setup.search.trim() && !$setup.backend.loading && !$setup.slim)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_290, [
                                            _createTextVNode(" No available cells in "),
                                            _createElementVNode("strong", null, _toDisplayString($setup.currentDatasetLabel), 1 /* TEXT */),
                                            _createTextVNode(". "),
                                            ($setup.suggestedClaimDataset)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _hoisted_291,
                                                  _createTextVNode("Switch to "),
                                                  _createElementVNode("strong", null, _toDisplayString($setup.suggestedClaimDataset), 1 /* TEXT */),
                                                  _createTextVNode(" to claim a cell. ")
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : _createCommentVNode("v-if", true)
                                          ]))
                                        : ($setup.filteredCells.length === 0 && !$setup.backend.loading && !$setup.slim)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_292, "No matching cells"))
                                          : _createCommentVNode("v-if", true),
                                    ($setup.filter === 'giants' && !$setup.slim)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_293, [
                                          _createTextVNode(" Help discover giant interneurons. These cell types have never been mapped before! You may hold one Super Quest at a time for up to 2 months. Pyr counts your active time on it, which helps the lab learn how long these cells take. For more info, see "),
                                          _createElementVNode("a", {
                                            href: $setup.SUPER_QUEST_BLOG,
                                            target: "_blank",
                                            rel: "noopener"
                                          }, "the Super Quests blog post"),
                                          _createTextVNode(". ")
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" The Cell Library's neuron stays on the slim bar (Ames 2026-10-20) "),
                                    ($setup.slim)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 9,
                                          src: $setup.neuronIcon,
                                          class: "nge-cl-icon nge-cl-slim-icon",
                                          alt: "",
                                          "aria-hidden": "true"
                                        }, null, 8 /* PROPS */, _hoisted_294))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.slim)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 10,
                                          class: "nge-cl-slim-expand",
                                          title: "Full view",
                                          "aria-label": "Full view",
                                          onClick: $setup.expandAndStay
                                        }, _hoisted_296))
                                      : _createCommentVNode("v-if", true),
                                    ($setup.slim && $setup.myOpenClaims.length > ($setup.slimClaimIndex >= 0 ? 1 : 0))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 11,
                                          class: "nge-cl-slim-next",
                                          disabled: $setup.steppingClaim,
                                          title: $setup.slimClaimIndex >= 0 ? `Next claimed cell (this is ${$setup.slimClaimIndex + 1} of ${$setup.myOpenClaims.length})` : `Go to your claimed cells (${$setup.myOpenClaims.length})`,
                                          "aria-label": "Next claimed cell",
                                          onClick: $setup.nextClaim
                                        }, _hoisted_299, 8 /* PROPS */, _hoisted_297))
                                      : _createCommentVNode("v-if", true),
                                    _createCommentVNode(" The empty slim bar: nothing to work on, so offer the next cell. "),
                                    ($setup.slimEmpty && !$setup.myOpenClaims.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_300, [
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn nge-cl-btn--claim nge-cl-slim-claim",
                                            disabled: !$setup.canClaimNew || $setup.claimingNew || !$setup.isLoggedIn,
                                            title: !$setup.isLoggedIn ? 'Sign in to claim cells'
                      : $setup.canClaimNew ? `Claims the next unclaimed cell in ${$setup.currentDatasetLabel} (the top of the Available tab) and takes you to it. Not for you? Release it from My Cells.`
                      : `No unclaimed cells left in ${$setup.currentDatasetLabel}. Open the full view to switch datasets.`,
                                            onClick: $setup.claimNewCell
                                          }, _toDisplayString($setup.claimingNew ? 'Claiming…' : $setup.canClaimNew ? '＋ Claim a new cell' : 'No cells left to claim here'), 9 /* TEXT, PROPS */, _hoisted_301)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listCells, (cell) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: cell.taskId ?? cell.segId
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["nge-cl-row", {
              'nge-cl-row--done': cell.status === 'completed',
              'nge-cl-row--mine': $setup.isMyClaim(cell),
              'nge-cl-row--jumped': cell.segId === $setup.jumpedSegId,
            }])
                                        }, [
                                          _createCommentVNode(" Left: status pip + name "),
                                          _createElementVNode("div", _hoisted_302, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["nge-cl-pip", $setup.statusClass(cell.status)])
                                            }, null, 2 /* CLASS */),
                                            _createElementVNode("div", _hoisted_303, [
                                              _createElementVNode("div", {
                                                class: "nge-cl-row-name",
                                                onClick: $event => ($setup.copyId(cell.segId)),
                                                title: 'Click to copy ' + cell.segId
                                              }, [
                                                _createElementVNode("span", {
                                                  title: cell.liveSegId ? `Updated after edits. Listed as ${cell.segId}` : undefined
                                                }, _toDisplayString($setup.history.getNickname(cell.segId) || cell.liveSegId || cell.segId), 9 /* TEXT, PROPS */, _hoisted_305),
                                                ($setup.copiedId === cell.segId)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_306, "copied"))
                                                  : _createCommentVNode("v-if", true)
                                              ], 8 /* PROPS */, _hoisted_304),
                                              _createElementVNode("div", _hoisted_307, [
                                                _createCommentVNode(" No \"viewing\" word: the green bar on the row says it (Ames 2026-10-20) "),
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["nge-cl-badge", $setup.statusClass(cell.status)])
                                                }, _toDisplayString($setup.statusLabel(cell.status)), 3 /* TEXT, CLASS */),
                                                (cell.assignedTo)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_308, _toDisplayString($setup.getCachedUserName(cell.assignedTo)), 1 /* TEXT */))
                                                  : (cell.sheetHold)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_309, _toDisplayString(cell.sheetAssignee ? cell.sheetAssignee + ' · ' : '') + _toDisplayString(cell.sheetHold), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                (cell.aiType)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 2,
                                                      class: "nge-cl-badge nge-cl-ai-type",
                                                      title: $setup.aiTypeTitle(cell.aiType)
                                                    }, "AI: " + _toDisplayString(cell.aiType), 9 /* TEXT, PROPS */, _hoisted_310))
                                                  : _createCommentVNode("v-if", true),
                                                (cell.quest)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_311, "Super Quest"))
                                                  : _createCommentVNode("v-if", true),
                                                (cell.quest && cell.questCategory)
                                                  ? (_openBlock(), _createElementBlock("span", {
                                                      key: 4,
                                                      class: "nge-cl-notes nge-cl-giant-cat",
                                                      title: cell.questCategory
                                                    }, _toDisplayString(cell.questCategory), 9 /* TEXT, PROPS */, _hoisted_312))
                                                  : _createCommentVNode("v-if", true),
                                                (/^Hunt (cell|candidate)/.test(cell.notes || ''))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_313, "Hunt candidate"))
                                                  : _createCommentVNode("v-if", true),
                                                _createCommentVNode(" The Hunt candidate tag says it (its tooltip has the note) "),
                                                (cell.notes && !/^Hunt (cell|candidate)/.test(cell.notes))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_314, _toDisplayString(cell.notes), 1 /* TEXT */))
                                                  : _createCommentVNode("v-if", true)
                                              ]),
                                              ($setup.questEndsSoon(cell))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_315, _toDisplayString($setup.questEndsSoon(cell)), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                              ($setup.isMyClaim(cell) && $setup.claimTimeLabel(cell.taskId))
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: _normalizeClass(["nge-cl-time", { 'nge-cl-time--on': $setup.claimTime.running === cell.taskId }]),
                                                    title: "Your active time on this cell: counted while the cell is on screen, Pyr is in front, and you have worked on it in the last 5 minutes: moving, turning or zooming the view, a mark, a highlight, a merge or cut, or Save view."
                                                  }, "Active time: " + _toDisplayString($setup.claimTimeLabel(cell.taskId)), 3 /* TEXT, CLASS */))
                                                : _createCommentVNode("v-if", true)
                                            ])
                                          ]),
                                          _createCommentVNode(" Right: actions "),
                                          _createElementVNode("div", _hoisted_316, [
                                            _createCommentVNode(" Save view comes first: it shows on the claim being worked on\n                   only, so the buttons after it stay put on every row (toknow,\n                   report 236). "),
                                            ($setup.isWorkingClaim(cell))
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: _normalizeClass(["nge-cl-btn nge-cl-btn--saveview", { 'nge-cl-btn--saved': $setup.savedViewAt[cell.taskId] }]),
                                                  disabled: $setup.savingView === cell.taskId,
                                                  onClick: $event => ($setup.saveClaimView(cell)),
                                                  title: "Save your current view (annotations, layers, camera) to this claim. The ↗ button opens it again."
                                                }, [
                                                  ($setup.savingView === cell.taskId)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_318))
                                                    : _createCommentVNode("v-if", true),
                                                  _createTextVNode(_toDisplayString($setup.savingView === cell.taskId ? 'Saving…' : $setup.savedViewAt[cell.taskId] ? 'Saved ✓' : 'Save view'), 1 /* TEXT */)
                                                ], 10 /* CLASS, PROPS */, _hoisted_317))
                                              : ($setup.isMyClaim(cell) && cell.taskId && cell.status !== 'completed')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createCommentVNode(" Your other open claims: when their view was last saved, in the\n                   spot Save view takes on the one you are working on. "),
                                                    _createElementVNode("span", {
                                                      class: "nge-cl-saved-at",
                                                      title: $setup.savedAtLabel(cell).title
                                                    }, _toDisplayString($setup.savedAtLabel(cell).text), 9 /* TEXT, PROPS */, _hoisted_319)
                                                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                : _createCommentVNode("v-if", true),
                                            _createElementVNode("button", {
                                              class: _normalizeClass(["nge-cl-btn nge-cl-btn--jump", { 'nge-cl-btn--jump-active': cell.segId === $setup.jumpedSegId }]),
                                              onClick: $event => ($setup.onRowJump(cell)),
                                              title: cell.segId === $setup.jumpedSegId ? 'Currently viewing — jump again' : 'Jump to segment'
                                            }, "↗", 10 /* CLASS, PROPS */, _hoisted_320),
                                            (cell.status === 'pending' && $setup.isLoggedIn)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 2,
                                                  class: "nge-cl-btn nge-cl-btn--claim",
                                                  disabled: $setup.claiming.has($setup.cellKey(cell)),
                                                  onClick: $event => ($setup.claimCell(cell))
                                                }, [
                                                  ($setup.claiming.has($setup.cellKey(cell)))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_322))
                                                    : _createCommentVNode("v-if", true),
                                                  _createTextVNode(_toDisplayString($setup.claiming.has($setup.cellKey(cell)) ? 'Claiming…' : 'Claim'), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_321))
                                              : _createCommentVNode("v-if", true),
                                            ($setup.isMyClaim(cell) && $setup.teamsHere && $setup.teamsOnDataset(cell.dataset) && cell.status !== 'completed')
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 3,
                                                  class: "nge-cl-btn nge-cl-btn--team",
                                                  disabled: $setup.teamingUp === $setup.cellKey(cell),
                                                  onClick: $event => ($setup.teamUpOnClaim(cell)),
                                                  title: "Work on this cell with up to three other players, each when they can. Opens the Teams tab."
                                                }, _toDisplayString($setup.teamingUp === $setup.cellKey(cell) ? 'Starting…' : '👥 Team up'), 9 /* TEXT, PROPS */, _hoisted_323))
                                              : _createCommentVNode("v-if", true),
                                            ($setup.isMyClaim(cell))
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 4,
                                                  class: "nge-cl-btn nge-cl-btn--release",
                                                  disabled: $setup.releasing.has($setup.releaseKey(cell)),
                                                  onClick: $event => ($setup.releaseCell(cell)),
                                                  title: "Release claim"
                                                }, [
                                                  ($setup.releasing.has($setup.releaseKey(cell)))
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_325))
                                                    : _createCommentVNode("v-if", true),
                                                  _createTextVNode(_toDisplayString($setup.releasing.has($setup.releaseKey(cell)) ? 'Releasing…' : 'Release'), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_324))
                                              : _createCommentVNode("v-if", true),
                                            ($setup.isMyClaim(cell))
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 5,
                                                  class: _normalizeClass(["nge-cl-btn nge-cl-btn--complete", { 'nge-cl-btn--complete-open': $setup.completing?.key === $setup.cellKey(cell) }]),
                                                  onClick: $event => ($setup.completing?.key === $setup.cellKey(cell) ? ($setup.completing = null) : $setup.openComplete(cell))
                                                }, "Complete", 10 /* CLASS, PROPS */, _hoisted_326))
                                              : _createCommentVNode("v-if", true)
                                          ])
                                        ], 2 /* CLASS */),
                                        _createCommentVNode(" MEC: the lab marks on the cell in view, one line that opens\n               into a checklist (Ames 2026-10-24). In the Complete form\n               instead while that is open. "),
                                        ($setup.showsMecMarks(cell) && !($setup.completing && $setup.completing.key === $setup.cellKey(cell)))
                                          ? (_openBlock(), _createBlock($setup["MecMarkStatus"], {
                                              key: 0,
                                              "super-quest": cell.quest,
                                              started: $setup.marksStartLine(cell)
                                            }, null, 8 /* PROPS */, ["super-quest", "started"]))
                                          : _createCommentVNode("v-if", true),
                                        _createCommentVNode(" Complete: the finished cell's link, and the crosshairs inside it,\n               before anything is written (Amy 2026-09-28). "),
                                        ($setup.completing && $setup.completing.key === $setup.cellKey(cell))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_327, [
                                              _hoisted_328,
                                              ($setup.showsMecMarks(cell))
                                                ? (_openBlock(), _createBlock($setup["MecMarkStatus"], {
                                                    key: 0,
                                                    "start-open": "",
                                                    "super-quest": cell.quest,
                                                    started: $setup.marksStartLine(cell),
                                                    class: "nge-cl-complete-marks"
                                                  }, null, 8 /* PROPS */, ["super-quest", "started"]))
                                                : _createCommentVNode("v-if", true),
                                              ($setup.completeStatusesFor(cell.dataset).length)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _hoisted_329,
                                                    _createElementVNode("div", _hoisted_330, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.completeStatusesFor(cell.dataset), (o) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                          key: o.value,
                                                          type: "button",
                                                          role: "radio",
                                                          class: _normalizeClass(["nge-cl-complete-status", { 'nge-cl-complete-status--on': $setup.completing.status === o.value }]),
                                                          "aria-checked": $setup.completing.status === o.value ? 'true' : 'false',
                                                          title: o.hint,
                                                          onClick: $event => ($setup.completing.status = o.value)
                                                        }, _toDisplayString(o.value), 11 /* TEXT, CLASS, PROPS */, _hoisted_331))
                                                      }), 128 /* KEYED_FRAGMENT */))
                                                    ])
                                                  ], 64 /* STABLE_FRAGMENT */))
                                                : _createCommentVNode("v-if", true),
                                              _createCommentVNode(" The cell's type, saved with the completion (Nseraf 2026-10-19):\n                 the same list as the Cell Profile, or typed. Optional. "),
                                              ($setup.cellTypesFor(cell).length)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    _hoisted_332,
                                                    _createCommentVNode(" The lab's AI type stands; a player only says when it is wrong\n                   (Ames 2026-10-19), and only that correction is saved. "),
                                                    (cell.aiType && !$setup.completing.correcting)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_333, [
                                                          _createElementVNode("span", {
                                                            title: $setup.aiTypeTitle(cell.aiType)
                                                          }, [
                                                            _createElementVNode("b", null, _toDisplayString($setup.cellTypeLabel(cell.aiType)), 1 /* TEXT */),
                                                            _createTextVNode(", the lab's AI prediction")
                                                          ], 8 /* PROPS */, _hoisted_334),
                                                          _createElementVNode("button", {
                                                            type: "button",
                                                            class: "nge-cl-btn",
                                                            onClick: _cache[99] || (_cache[99] = $event => ($setup.completing.correcting = true)),
                                                            title: "Only if you are sure the AI is wrong. What you choose is saved as your correction."
                                                          }, "Wrong? Correct it")
                                                        ]))
                                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                          (cell.aiType)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_335, [
                                                                _createElementVNode("span", null, [
                                                                  _createTextVNode("The AI said "),
                                                                  _createElementVNode("b", {
                                                                    title: $setup.aiTypeTitle(cell.aiType)
                                                                  }, _toDisplayString($setup.cellTypeLabel(cell.aiType)), 9 /* TEXT, PROPS */, _hoisted_336),
                                                                  _createTextVNode(". Your choice is saved as a correction.")
                                                                ]),
                                                                _createElementVNode("button", {
                                                                  type: "button",
                                                                  class: "nge-cl-btn",
                                                                  onClick: _cache[100] || (_cache[100] = $event => {$setup.completing.correcting = false; $setup.completing.cellType = ''; $setup.completing.cellTypeCustom = ''})
                                                                }, "Keep the AI's type")
                                                              ]))
                                                            : _createCommentVNode("v-if", true),
                                                          _createElementVNode("div", _hoisted_337, [
                                                            _withDirectives(_createElementVNode("select", {
                                                              "onUpdate:modelValue": _cache[101] || (_cache[101] = $event => (($setup.completing.cellType) = $event)),
                                                              class: "nge-cl-search-input nge-cl-complete-type",
                                                              "aria-label": "Cell type",
                                                              onChange: _cache[102] || (_cache[102] = $event => ($setup.completing.cellTypeCustom = '')),
                                                              onKeydown: _cache[103] || (_cache[103] = _withModifiers(() => {}, ["stop"])),
                                                              onKeyup: _cache[104] || (_cache[104] = _withModifiers(() => {}, ["stop"])),
                                                              onKeypress: _cache[105] || (_cache[105] = _withModifiers(() => {}, ["stop"]))
                                                            }, [
                                                              _hoisted_338,
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cellTypesFor(cell), (t) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                  key: t,
                                                                  value: t,
                                                                  title: $setup.typeTitle(t)
                                                                }, _toDisplayString($setup.cellTypeLabel(t)), 9 /* TEXT, PROPS */, _hoisted_339))
                                                              }), 128 /* KEYED_FRAGMENT */))
                                                            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                                              [_vModelSelect, $setup.completing.cellType]
                                                            ]),
                                                            _withDirectives(_createElementVNode("input", {
                                                              "onUpdate:modelValue": _cache[106] || (_cache[106] = $event => (($setup.completing.cellTypeCustom) = $event)),
                                                              class: "nge-cl-search-input nge-cl-complete-type",
                                                              placeholder: "Or type your own",
                                                              maxlength: "120",
                                                              "aria-label": "Or type your own cell type",
                                                              onInput: _cache[107] || (_cache[107] = $event => ($setup.completing.cellTypeCustom.trim() && ($setup.completing.cellType = ''))),
                                                              onKeydown: _cache[108] || (_cache[108] = _withModifiers(() => {}, ["stop"])),
                                                              onKeyup: _cache[109] || (_cache[109] = _withModifiers(() => {}, ["stop"])),
                                                              onKeypress: _cache[110] || (_cache[110] = _withModifiers(() => {}, ["stop"]))
                                                            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                                              [_vModelText, $setup.completing.cellTypeCustom]
                                                            ])
                                                          ])
                                                        ], 64 /* STABLE_FRAGMENT */)),
                                                    ($setup.completing.typeNote)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_340, _toDisplayString($setup.completing.typeNote), 1 /* TEXT */))
                                                      : _createCommentVNode("v-if", true)
                                                  ], 64 /* STABLE_FRAGMENT */))
                                                : _createCommentVNode("v-if", true),
                                              _hoisted_341,
                                              _createElementVNode("div", _hoisted_342, [
                                                _withDirectives(_createElementVNode("input", {
                                                  "onUpdate:modelValue": _cache[111] || (_cache[111] = $event => (($setup.completing.link) = $event)),
                                                  class: "nge-cl-search-input",
                                                  placeholder: "https://… (the view of your finished cell)",
                                                  onKeydown: _cache[112] || (_cache[112] = _withModifiers(() => {}, ["stop"])),
                                                  onKeyup: _cache[113] || (_cache[113] = _withModifiers(() => {}, ["stop"])),
                                                  onKeypress: _cache[114] || (_cache[114] = _withModifiers(() => {}, ["stop"]))
                                                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                                  [_vModelText, $setup.completing.link]
                                                ]),
                                                _createElementVNode("button", {
                                                  class: "nge-cl-btn",
                                                  disabled: $setup.completing.minting,
                                                  onClick: $setup.useCurrentViewLink,
                                                  title: "Make a short link of what you are looking at now"
                                                }, _toDisplayString($setup.completing.minting ? '…' : 'Use my current view'), 9 /* TEXT, PROPS */, _hoisted_343)
                                              ]),
                                              ($setup.completing.link && !$setup.linkLooksValid($setup.completing.link))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_344, " Paste a full https viewer link. "))
                                                : _createCommentVNode("v-if", true),
                                              _hoisted_345,
                                              _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[115] || (_cache[115] = $event => (($setup.completing.notes) = $event)),
                                                class: "nge-cl-search-input nge-cl-complete-notes",
                                                rows: "2",
                                                maxlength: "1000",
                                                placeholder: "Anything the reviewers should know, e.g. axon cut off at the edge",
                                                onKeydown: _cache[116] || (_cache[116] = _withModifiers(() => {}, ["stop"])),
                                                onKeyup: _cache[117] || (_cache[117] = _withModifiers(() => {}, ["stop"])),
                                                onKeypress: _cache[118] || (_cache[118] = _withModifiers(() => {}, ["stop"]))
                                              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                                [_vModelText, $setup.completing.notes]
                                              ]),
                                              _hoisted_346,
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["nge-cl-complete-msg", $setup.completing.checking ? '' : ($setup.completing.ok ? 'nge-cl-complete-msg--ok' : 'nge-cl-complete-msg--bad')])
                                              }, [
                                                ($setup.completing.checking)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createTextVNode("Checking where the crosshairs are…")
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createTextVNode(_toDisplayString($setup.completing.ok ? '✓ ' : '✗ ') + _toDisplayString($setup.completing.message), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */)),
                                                _createElementVNode("button", {
                                                  class: "nge-cl-complete-recheck",
                                                  disabled: $setup.completing.checking,
                                                  onClick: $event => ($setup.runCrosshairCheck(cell))
                                                }, "Check again", 8 /* PROPS */, _hoisted_347)
                                              ], 2 /* CLASS */),
                                              _createElementVNode("div", _hoisted_348, [
                                                _createElementVNode("button", {
                                                  class: "nge-cl-btn nge-cl-btn--complete",
                                                  disabled: $setup.completing.submitting || $setup.completing.checking || !$setup.completing.ok || !$setup.linkLooksValid($setup.completing.link) || $setup.statusMissing(cell),
                                                  title: $setup.statusMissing(cell) ? 'Pick how the cell ended first' : undefined,
                                                  onClick: $event => ($setup.submitComplete(cell))
                                                }, [
                                                  ($setup.completing.submitting)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_350))
                                                    : _createCommentVNode("v-if", true),
                                                  _createTextVNode(_toDisplayString($setup.completing.submitting ? ($setup.completing.checking ? 'Checking crosshairs…' : 'Saving…') : 'Mark complete'), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_349),
                                                _createElementVNode("button", {
                                                  class: "nge-cl-btn",
                                                  disabled: $setup.completing.submitting,
                                                  onClick: _cache[119] || (_cache[119] = $event => ($setup.completing = null))
                                                }, "Cancel", 8 /* PROPS */, _hoisted_351)
                                              ])
                                            ]))
                                          : _createCommentVNode("v-if", true)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    (!$setup.slimCell && ($setup.filteredCells.length > $setup.shownCells.length || ($setup.serverHasMore && !$setup.search.trim())))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_352, [
                                          _createElementVNode("span", null, "Showing " + _toDisplayString($setup.shownCells.length.toLocaleString()) + " of " + _toDisplayString(Math.max($setup.tabTotal, $setup.filteredCells.length).toLocaleString()) + ". Search finds any of them.", 1 /* TEXT */),
                                          _createElementVNode("button", {
                                            class: "nge-cl-btn",
                                            disabled: !!$setup.backend.loadingMore,
                                            onClick: $setup.loadMore
                                          }, [
                                            ($setup.backend.loadingMore)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_354))
                                              : _createCommentVNode("v-if", true),
                                            _createTextVNode(_toDisplayString($setup.backend.loadingMore ? 'Loading…' : 'Load more'), 1 /* TEXT */)
                                          ], 8 /* PROPS */, _hoisted_353)
                                        ]))
                                      : _createCommentVNode("v-if", true)
                                  ])
                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
            _createCommentVNode(" Login prompt "),
            (!$setup.isLoggedIn && $setup.cells.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_355, " Log in to claim and complete cells "))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Resize handle (bottom-right corner) "),
            _createElementVNode("div", {
              class: "nge-cl-resize",
              onMousedown: $setup.startResize,
              title: "Drag to resize"
            }, _hoisted_357, 32 /* HYDRATE_EVENTS */)
          ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */)
        ]),
        _: 1 /* STABLE */
      })
    ])),
    _createCommentVNode(" One help request in its own window (⧉ on a request; annkri, #227). "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.poppedHelpId)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "popoutEl",
            class: _normalizeClass(["nge-cl-popout", { 'nge-cl-popout--dragging': $setup.popoutDragging }]),
            style: _normalizeStyle($setup.popoutPosStyle),
            role: "dialog",
            "aria-label": "Help request"
          }, [
            _createElementVNode("div", {
              class: "nge-cl-popout-head",
              title: "Drag to move",
              onPointerdown: _cache[120] || (_cache[120] = (...args) => ($setup.startPopoutDrag && $setup.startPopoutDrag(...args)))
            }, [
              _hoisted_358,
              _createElementVNode("button", {
                class: "nge-cl-close",
                title: "Close this window",
                "aria-label": "Close",
                onClick: $setup.closePopout
              }, "×")
            ], 32 /* HYDRATE_EVENTS */),
            (!$setup.poppedReq)
              ? (_openBlock(), _createElementBlock("div", _hoisted_359, _toDisplayString($setup.helpStore.requests.length ? 'This help request is no longer in the list.' : 'Loading…'), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_360, [
                  _createElementVNode("div", _hoisted_361, [
                    _createElementVNode("b", null, _toDisplayString($setup.poppedReq.userName || 'A player'), 1 /* TEXT */),
                    _createTextVNode(" asked " + _toDisplayString($setup.relativeTime($setup.poppedReq.createdAt)) + " ", 1 /* TEXT */),
                    _createElementVNode("span", {
                      class: _normalizeClass(["nge-cl-badge nge-cl-status--help", { 'nge-cl-badge--live': $setup.isLiveHelp($setup.poppedReq) }])
                    }, _toDisplayString($setup.poppedReq.issueType), 3 /* TEXT, CLASS */),
                    ($setup.poppedReq.resolved)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_362, "✓ Solved" + _toDisplayString($setup.poppedReq.resolvedByName ? ' by ' + $setup.poppedReq.resolvedByName : ''), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_363, [
                    ($setup.poppedReq.segId)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "nge-cl-row-name",
                          onClick: _cache[121] || (_cache[121] = $event => ($setup.copyId($setup.poppedReq.segId))),
                          title: 'Click to copy ' + $setup.poppedReq.segId
                        }, [
                          _createTextVNode(" Cell " + _toDisplayString($setup.poppedReq.segId), 1 /* TEXT */),
                          ($setup.copiedId === $setup.poppedReq.segId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_365, "copied"))
                            : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_364))
                      : _createCommentVNode("v-if", true),
                    ($setup.poppedReq.dataset)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_366, _toDisplayString($setup.datasetHeading($setup.poppedReq.dataset)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.poppedReq.note)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_367, _toDisplayString($setup.poppedReq.note), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_368, "They did not write a question.")),
                  ($setup.poppedReq.screenshotUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: $setup.poppedReq.screenshotUrl,
                        target: "_blank",
                        rel: "noopener",
                        class: "nge-cl-popout-shot",
                        title: "Open the full picture"
                      }, [
                        _createElementVNode("img", {
                          src: $setup.poppedReq.screenshotUrl,
                          alt: "Their picture"
                        }, null, 8 /* PROPS */, _hoisted_370)
                      ], 8 /* PROPS */, _hoisted_369))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_371, [
                    ($setup.poppedReq.viewUrl)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "nge-cl-response-link",
                          href: "#",
                          onClick: _cache[122] || (_cache[122] = _withModifiers($event => ($setup.openResponseUrl($setup.poppedReq.viewUrl)), ["prevent"])),
                          title: "Load the view they were looking at"
                        }, "↗ Open their view"))
                      : _createCommentVNode("v-if", true),
                    ($setup.poppedReq.annotationLayer)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_372, "📐 " + _toDisplayString($setup.poppedReq.annotationLayer === 'All annotation layers' ? $setup.poppedReq.annotationLayer : ($setup.poppedReq.annotationLayer.includes(', ') ? 'Layers: ' : 'Layer: ') + $setup.poppedReq.annotationLayer), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.solvedFlash && $setup.solvedFlash === $setup.poppedReq.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_373, [
                        _hoisted_374,
                        _createElementVNode("img", {
                          src: $setup.nurroCelebrate,
                          class: "nge-cl-solved-nurro",
                          alt: ""
                        }, null, 8 /* PROPS */, _hoisted_375),
                        _hoisted_376
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_377, [
                    _createElementVNode("button", {
                      class: "nge-cl-btn",
                      onClick: _cache[123] || (_cache[123] = $event => ($setup.jumpToReq($setup.poppedReq))),
                      title: "Fly the view to this cell"
                    }, "↗ Jump to the cell"),
                    (!$setup.poppedReq.resolved)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "nge-cl-btn",
                          onClick: _cache[124] || (_cache[124] = $event => ($setup.toggleResponseForm($setup.poppedReq.id)))
                        }, _toDisplayString($setup.respondingTo === $setup.poppedReq.id ? 'Cancel reply' : '💬 Reply'), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.teamAllowed && !$setup.poppedReq.resolved && $setup.isLiveHelp($setup.poppedReq) && $setup.poppedReq.userId && $setup.poppedReq.userId !== $setup.backend.userId)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "nge-cl-btn nge-cl-btn--join",
                          disabled: $setup.offeredTo.has($setup.poppedReq.id),
                          onClick: _cache[125] || (_cache[125] = $event => ($setup.offerToJoin($setup.poppedReq)))
                        }, _toDisplayString($setup.offeredTo.has($setup.poppedReq.id) ? 'Offered' : 'Join'), 9 /* TEXT, PROPS */, _hoisted_378))
                      : _createCommentVNode("v-if", true),
                    (!$setup.poppedReq.resolved && $setup.canResolve($setup.poppedReq))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "nge-cl-btn nge-cl-btn--complete",
                          onClick: _cache[126] || (_cache[126] = $event => ($setup.resolveReq($setup.poppedReq))),
                          title: $setup.poppedReq.userId === $setup.backend.userId ? 'Your question is answered: move it to Resolved for everyone' : 'Close this request for everyone: it moves to Resolved'
                        }, "Mark solved", 8 /* PROPS */, _hoisted_379))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.respondingTo === $setup.poppedReq.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_380, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[127] || (_cache[127] = $event => (($setup.responseNote) = $event)),
                          placeholder: "Write your reply... (Enter to send, Shift+Enter for a new line)",
                          class: "nge-cl-response-textarea",
                          rows: "3",
                          onKeydown: [
                            _cache[128] || (_cache[128] = _withModifiers(() => {}, ["stop"])),
                            _cache[131] || (_cache[131] = _withKeys(_withModifiers($event => ($setup.submitResponse($setup.poppedReq)), ["exact","prevent"]), ["enter"]))
                          ],
                          onKeyup: _cache[129] || (_cache[129] = _withModifiers(() => {}, ["stop"])),
                          onKeypress: _cache[130] || (_cache[130] = _withModifiers(() => {}, ["stop"]))
                        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                          [_vModelText, $setup.responseNote]
                        ]),
                        _createElementVNode("div", _hoisted_381, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[132] || (_cache[132] = $event => (($setup.responseUrl) = $event)),
                            placeholder: "Neuroglancer state URL (optional)",
                            class: "nge-cl-response-input",
                            onKeydown: _cache[133] || (_cache[133] = _withModifiers(() => {}, ["stop"])),
                            onKeyup: _cache[134] || (_cache[134] = _withModifiers(() => {}, ["stop"])),
                            onKeypress: _cache[135] || (_cache[135] = _withModifiers(() => {}, ["stop"]))
                          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelText, $setup.responseUrl]
                          ]),
                          _createElementVNode("button", {
                            class: "nge-cl-btn nge-cl-btn--copy-state",
                            onClick: $setup.copyCurrentState,
                            title: "Copy current viewer state URL"
                          }, "📋 State")
                        ]),
                        ($setup.getAnnotationLayers().length > 0)
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              "onUpdate:modelValue": _cache[136] || (_cache[136] = $event => (($setup.responseAnnotationLayer) = $event)),
                              class: "nge-cl-response-input"
                            }, [
                              _hoisted_382,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAnnotationLayers(), (layer) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: layer,
                                  value: layer
                                }, _toDisplayString(layer), 9 /* TEXT, PROPS */, _hoisted_383))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */)), [
                              [_vModelSelect, $setup.responseAnnotationLayer]
                            ])
                          : _createCommentVNode("v-if", true),
                        (!$setup.responseScreenshotUrl)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "nge-cl-btn nge-cl-help-shot-btn",
                              onClick: _cache[137] || (_cache[137] = $event => ($setup.showResponseScreenshotDialog = true)),
                              title: "Attach a screenshot of the current view"
                            }, "📷 Attach screenshot"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_384, [
                              _createElementVNode("img", {
                                src: $setup.responseScreenshotUrl,
                                alt: "Reply screenshot"
                              }, null, 8 /* PROPS */, _hoisted_385),
                              _createElementVNode("button", {
                                class: "nge-cl-help-shot-remove",
                                onClick: $setup.clearResponseScreenshot,
                                title: "Remove screenshot"
                              }, "×")
                            ])),
                        _createElementVNode("button", {
                          class: "nge-cl-btn nge-cl-btn--submit-response",
                          disabled: !$setup.responseNote.trim() && !$setup.responseScreenshotUrl,
                          onClick: _cache[138] || (_cache[138] = $event => ($setup.submitResponse($setup.poppedReq)))
                        }, "Send reply", 8 /* PROPS */, _hoisted_386),
                        ($setup.canResolve($setup.poppedReq))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "nge-cl-btn nge-cl-btn--submit-response nge-cl-btn--resolve",
                              disabled: !$setup.responseNote.trim() && !$setup.responseScreenshotUrl,
                              title: "Send the reply and move the request to Resolved for everyone",
                              onClick: _cache[139] || (_cache[139] = $event => ($setup.submitResponse($setup.poppedReq, true)))
                            }, "Reply and mark solved", 8 /* PROPS */, _hoisted_387))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_388, _toDisplayString($setup.poppedReq.responses?.length ? ($setup.poppedReq.responses.length === 1 ? '1 reply' : $setup.poppedReq.responses.length + ' replies') : 'No replies yet'), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.poppedReq.responses || [], (resp) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: resp.id,
                      class: "nge-cl-popout-reply"
                    }, [
                      _createElementVNode("div", _hoisted_389, [
                        _createTextVNode("💬 " + _toDisplayString(resp.userName || 'Reply'), 1 /* TEXT */),
                        (resp.resolved)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_390, " · solved it"))
                          : _createCommentVNode("v-if", true)
                      ]),
                      (resp.note)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_391, _toDisplayString(resp.note), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (resp.url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "nge-cl-response-link",
                            onClick: _withModifiers($event => ($setup.openResponseUrl(resp.url)), ["prevent"]),
                            href: "#"
                          }, "↗ View linked state", 8 /* PROPS */, _hoisted_392))
                        : _createCommentVNode("v-if", true),
                      (resp.annotationLayer)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_393, "📐 Layer: " + _toDisplayString(resp.annotationLayer), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (resp.screenshotUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 3,
                            href: resp.screenshotUrl,
                            target: "_blank",
                            rel: "noopener",
                            class: "nge-cl-popout-shot",
                            title: "Open the full picture"
                          }, [
                            _createElementVNode("img", {
                              src: resp.screenshotUrl,
                              alt: "Reply picture"
                            }, null, 8 /* PROPS */, _hoisted_395)
                          ], 8 /* PROPS */, _hoisted_394))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
          ], 6 /* CLASS, STYLE */))
        : _createCommentVNode("v-if", true)
    ])),
    _createCommentVNode(" Cross-dataset jump confirmation modal "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.jumpConfirmReq)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "nge-cl-jumpconfirm-backdrop",
            onClick: _withModifiers($setup.cancelJumpConfirm, ["self"])
          }, [
            _createElementVNode("div", _hoisted_397, [
              _hoisted_398,
              _createElementVNode("div", _hoisted_399, [
                _createTextVNode(" This help request is on "),
                _createElementVNode("strong", null, _toDisplayString($setup.jumpConfirmReq.dataset), 1 /* TEXT */),
                _createTextVNode(". You're currently viewing "),
                _createElementVNode("strong", null, _toDisplayString($setup.activeDataset || 'an unknown dataset'), 1 /* TEXT */),
                _createTextVNode(". The viewer will reload with new layers — copy your current state URL first if you don't want to lose your spot. ")
              ]),
              (!$setup.jumpConfirmTargetDs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_400, " ⚠ This dataset isn't in the known dataset list. We'll jump to the segment but won't auto-switch layers — you may need to load it manually. "))
                : (!$setup.jumpConfirmTargetServerHasAuth())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_401, " ⚠ You haven't logged into this dataset's server yet. You'll be prompted to log in after the switch. "))
                  : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_402, [
                _createElementVNode("input", {
                  class: "nge-cl-jumpconfirm-url",
                  value: $setup.getCurrentUrl(),
                  readonly: "",
                  onClick: $setup.selectInputContents,
                  title: "Click to select, then copy"
                }, null, 8 /* PROPS */, _hoisted_403),
                _createElementVNode("button", {
                  class: "nge-cl-jumpconfirm-copy",
                  onClick: $setup.copyJumpConfirmUrl
                }, _toDisplayString($setup.jumpConfirmCopied ? '✓ Copied' : '📋 Copy URL'), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_404, [
                _createElementVNode("button", {
                  class: "nge-cl-jumpconfirm-save",
                  onClick: $setup.saveCurrentAsLink,
                  disabled: !$setup.backend.userId
                }, " 💾 Save link before switching ", 8 /* PROPS */, _hoisted_405)
              ]),
              _createElementVNode("div", _hoisted_406, [
                _createElementVNode("button", {
                  class: "nge-cl-jumpconfirm-cancel",
                  onClick: $setup.cancelJumpConfirm
                }, "Cancel"),
                _createElementVNode("button", {
                  class: "nge-cl-jumpconfirm-go",
                  onClick: $setup.confirmJump
                }, _toDisplayString($setup.jumpConfirmTargetDs ? 'Switch & Jump' : 'Jump anyway'), 1 /* TEXT */)
              ])
            ])
          ], 8 /* PROPS */, _hoisted_396))
        : _createCommentVNode("v-if", true)
    ])),
    _createCommentVNode(" Screenshot attach dialog for help requests "),
    _createVNode($setup["ScreenshotDialog"], {
      show: $setup.showHelpScreenshotDialog,
      mode: "attach",
      "hide-opener": ".nge-cl-panel",
      onClose: _cache[140] || (_cache[140] = $event => ($setup.showHelpScreenshotDialog = false)),
      onAttached: $setup.onHelpScreenshotAttached
    }, null, 8 /* PROPS */, ["show"]),
    _createVNode($setup["ScreenshotDialog"], {
      show: $setup.showResponseScreenshotDialog,
      mode: "attach",
      "hide-opener": ".nge-cl-panel",
      onClose: _cache[141] || (_cache[141] = $event => ($setup.showResponseScreenshotDialog = false)),
      onAttached: $setup.onResponseScreenshotAttached
    }, null, 8 /* PROPS */, ["show"]),
    _createVNode($setup["ScreenshotDialog"], {
      show: $setup.showLinkScreenshotDialog,
      mode: "attach",
      "hide-opener": ".nge-cl-panel",
      onClose: _cache[142] || (_cache[142] = $event => ($setup.showLinkScreenshotDialog = false)),
      onAttached: $setup.onLinkScreenshotAttached
    }, null, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}